module.exports = {

    // CONSTANT WORDS
    'constant.AVERAGE': 'media',

    // Supported languages
    'title.lang.es': 'Español',
    'title.lang.en': 'Inglés',

    // Contact Info
    'contact.info.header':           'Contáctenos',
    'contact.info.phone':            'Teléfono España (gratuito)',
    'contact.info.customer_service': '(24x7 atención al cliente)',

    // Entity names
    'entity.task.singular':            'tarea',
    'entity.task.plural':              'tareas',
    'entity.issue.singular':           'incidencia',
    'entity.issue.plural':             'incidencias',
    'entity.request.singular':         'petición',
    'entity.request.plural':           'peticiones',
    'entity.project.singular':         'proyecto',
    'entity.project.plural':           'proyectos',
    'entity.reservation.singular':     'reserva AWS',
    'entity.reservation.plural':       'reservas AWS',
    'entity.resource.singular':        'recurso',
    'entity.resource.plural':          'recursos',
    'entity.account.singular':         'cuenta',
    'entity.account.plural':           'cuentas',
    'entity.vendor.singular':          'proveedor',
    'entity.vendor.plural':            'proveedores',
    'entity.requester.singular':       'usuario',
    'entity.requester.plural':         'usuarios',
    'entity.company.singular':         'compañía',
    'entity.company.plural':           'compañías',
    'entity.serviceOffering.singular': 'servicio',
    'entity.serviceOffering.plural':   'servicios',
    'entity.credential.singular':      'credencial',
    'entity.credential.plural':        'credenciales',
    'entity.operationLog.singular':    'registro',
    'entity.operationLog.plural':      'registros',
    'entity.backup.singular':          'copia de seguridad',
    'entity.backup.plural':            'copias de seguridad',
    'entity.plan.singular':            'plan',
    'entity.plan.plural':              'planes',
    'entity.contact.singular':         'contacto',
    'entity.contact.plural':           'contactos',
    'entity.rol.singular':             'rol',
    'entity.rol.plural':               'roles',
    'entity.aws_ticket.singular':      'ticket',
    'entity.aws_ticket.plural':        'tickets',
    'entity.p200.singular':            'informe',
    'entity.p200.plural':              'informes',
    'entity.alert.singular':           'alerta',
    'entity.alert.plural':             'alertas',
    'entity.costCenter.singular':      'proyecto',
    'entity.costCenter.plural':        'proyectos',
    'entity.cost_center.singular':     'proyecto',
    'entity.cost_center.plural':       'proyectos',
    'entity.product.singular':         'servicio',
    'entity.product.plural':           'servicios',
    'entity.region.singular':          'region',
    'entity.region.plural':            'regiones',
    'entity.user.singular':            'usuario',
    'entity.user.plural':              'usuarios',
    'entity.event.singular':           'evento',
    'entity.event.plural':             'eventos',

    // Menu/submenu items
    'title.test':                       'Mis testes',
    'title.home':                       'Inicio',
    'title.error':                      'Error',
    'title.sign_in':                    'Iniciar sesión',
    'title.recover_password_mail':      'Escriba su e-mail',
    'title.recover_password':           'Recuperar contraseña',
    'title.dashboard':                  'Panel',
    'title.infrastructure':             'Recursos Cloud',
    'title.service_now':                'Soporte EMS',
    'title.service_now_name':           'Soporte gestionado de Equinix',
    'title.resources':                  'Recursos',
    'title.resources.show':             'Mostrar recurso: {name}',
    'subtitle.resources.show':          'Creado a {date}',
    'title.groups':                     'Grupos',
    'title.reports':                    'Facturación Cloud',
    'title.reservations':               'AWS Reservas',
    'title.consultancy':                'Soporte de servicios en la Nube',
    'title.internet':                   'Acceso de internet',
    'title.summary':                    'Resumen',
    'title.tasks':                      'Tareas',
    'title.issues':                     'Incidencias',
    'title.aws_support':                'Soporte AWS',
    'title.projects':                   'Proyectos',
    'title.settings':                   'Preferencias',
    'title.my_profile':                 'Mi perfil',
    'title.my_accounts':                'Mis cuentas',
    'title.my_security_credentials':    'Mis credenciales de seguridad',
    'title.view_user_profile':          'Ver perfil del usuario',
    'title.page_not_found':             'No encontrado',
    'title.nothing_to_see':             'Lo sentimos, el contenido al que intenta acceder no esta disponible en este momento.',
    'title.back_to_dashboard':          'Volver al panel',
    'title.temporary_disabled_account': 'Lo sentimos, en estos momentos no puede editarse esta cuenta.',
    'title.alerts':                     'Alertas de facturación',
    'title.cloudBilling.breakdown':     'Desglose de consumos',
    'title.ips':                        'IPS (Infrastructure Platform Service)',
    'title.ips_platform':               'Plataforma IPS',
    'title.global_information':         'Información Global',
    'title.ips_vcenter':                'Recursos VCenter',
    'title.ips_vcloud':                 'Recursos VCloud',
    'title.itsm':                       'Soporte',
    'title.itsm_active_tickets':        'Tickets activos',
    'title.itsm_all_tickets':           'Lista de tickets',
    'title.itsm_details':               'Detalles',
    'title.itsm_details_tickets':       'Detalles de tickets',
    'title.cloud':                      'Cloud',
    'title.backupPlatform':             'Plataforma de Backup',
    'title.monitoringPlatform':         'Monitorización',

    // Footer
    'title.help':  'Ayuda',
    'title.about': 'Acerca',
    'title.terms': 'T. y C.',

    // Login page
    'label.remember_credentials':          'Recordar mis credenciales',
    'label.username':                      'usuario',
    'label.password':                      'contraseña',
    'label.forgot_password':               '¡Olvidé mi contraseña!',
    'label.return_to_login':               'Volver a iniciar sesión',
    'label.mail_confirm':                  'Pronto recibirá un e-mail a la cuenta {email} con instrucciones para reestablecer su contraseña.',
    'label.password_recovering':           'Su contraseña ha sido cambiada correctamente. Por favor, ingrese con su nueva contraseña.',
    'label.password_policy.header':        'La contraseña debe cumplir los siguientes requisitos:',
    'label.password_policy.requirement.1': 'Debe contener al menos 12 caracteres.',
    'label.password_policy.requirement.2': 'Debe contener mayúsculas, minúsculas, números y caracteres especiales',
    'label.password_policy.requirement.3': 'No puede contener su nombre de usuario ni su correo electrónico',
    'label.password_policy.requirement.4': 'No puede ser igual a las últimas 5 contraseñas',
    'label.password_policy.error':         'La contraseña introducida no cumple los requisitos.',
    'btn.sign_in':                         'Iniciar sesión',
    'btn.signing_in':                      'Iniciando sesión...',

    // Consultancy
    'title.hours_by_customer':                   'Horas por cliente',
    'title.recent_projects':                     'Últimos proyectos activos',
    'title.recent_issues':                       'Peticiones activas (en progreso)',
    'title.latest_tasks':                        'Últimas tareas completadas',
    'title.name':                                'Nombre',
    'title.hours':                               'Horas',
    'title.hours_abbr':                          'Hs',
    'title.project':                             'Proyecto',
    'title.progress':                            'Progreso',
    'title.issue':                               'Petición',
    'title.status':                              'Estado',
    'title.issue_level':                         'Nivel de prioridad',
    'title.assigned_to':                         'Asignado a',
    'title.consultant':                          'Consultor',
    'title.consultants':                         'Consultores',
    'title.total':                               'Total',
    'title.customers':                           'Clientes',
    'title.manager':                             'Responsable',
    'title.description':                         'Descripción',
    'label.hours':                               'horas',
    'label.number_hours':                        '{num, plural, one {# h} other {# hs}}',
    'label.view_all_projects':                   'Ver todos los proyectos',
    'label.view_all_issues':                     'Ver todas las incidencias',
    'label.task_completed_on_date':              'Tareas completadas el {date}',
    'label.completed_by_person_on_date':         'Completada por {person} {others, plural, =0 {} other {(y # más)}} {date}',
    'label.related_to_issue_issue':              ', relacionada con la incidencia {issue}',
    'label.opened_by_person_on_date':            'Abierta por {person} el {date}',
    'label.person_completed_task_on_date':       '{others, plural, one {{person} completó} other {# consultores completaron}} la tarea {task} {date}',
    'label.displaying_count_entities_criteria':  'Mostrando {count, plural, one {# {entity}} other {# {entities}}} de acuerdo a sus criterios de búsqueda.',
    'label.there_are_count_entities_total':      'Hay {count} {entities} en total.',
    'label.there_are_no_entities_criteria':      'No hay {entities} que coincidan con sus criterios de búsqueda.',
    'label.there_are_no_entities':               'No hay {entities} cargados en el sistema.',
    'label.there_are_no_entities.female':        'No hay {entities} cargadas en el sistema.',
    'label.tasks':                               'Tareas',
    'label.task_types':                          'Tipos de tarea',
    'label.all_task_types':                      'Todos los tipos de tarea',
    'label.all_projects':                        'Todos los proyectos',
    'label.paren_unknown_paren':                 '(Desconocido)',
    'label.search':                              'Buscar',
    'label.search.selection':                    'Buscar en la selección',
    'title.search':                              'Escriba al menos %s caracteres para comenzar la búsqueda.',
    'placeholder.search_tasks':                  'Nombre, descripción...',
    'label.all_statuses':                        'Todos los estados',
    'label.all_states':                          'Todos los estados',
    'label.state':                               'Estado',
    'label.statuses':                            'Estados',
    'label.all_levels':                          'Todos los niveles',
    'label.datepicker':                          'Fecha',
    'label.levels':                              'Niveles',
    'label.all_vendors':                         'Todos los proveedores',
    'label.vendors':                             'Proveedores',
    'label.all_task':                            'Todas las tareas',
    'label.task':                                'Tareas',
    'label.all_accounts':                        'Todas las cuentas',
    'label.accounts':                            'Cuentas',
    'placeholder.account.search':                'Nombre de la cuenta...',
    'placeholder.vendor.search':                 'Nombre del proveedor...',
    'placeholder.costCenter.search':             'Nombre del proyecto...',
    'label.accounts.credentials':                'Credenciales',
    'label.all_resource_types':                  'Todos los tipos de recurso',
    'label.resource_types':                      'Tipos de recurso',
    'btn.add_resource':                          'Nuevo recurso',
    'placeholder.search_resources':              'ID de recurso, nombre de recurso',
    'label.select_resources':                    'Selecciona los recursos',
    'dropdown.all':                              'Todos',
    'dropdown.active':                           'Ejecutándose',
    'dropdown.stopped':                          'Detenidos',
    'dropdown.none':                             'Ninguno',
    'btn.add_associated_service':                'Nuevo servicio asociado',
    'btn.create_backup_job':                     'Crear tarea de copia de seguridad',
    'btn.start':                                 'Iniciar',
    'btn.stop':                                  'Detener',
    'btn.refresh_page':                          'Recargar',
    'btn.discover':                              'Descubrir',
    'btn.discover.counter':                      'Descubrir ({count})',
    'btn.resouces.click_to_discover':            'Pulse aquí para lanzar el proceso de descubrimiento de recursos',
    'btn.start_resource':                        'Iniciar recurso',
    'btn.stop_resource':                         'Detener recurso',
    'btn.reset_filter':                          'Limpiar filtros',
    'btn.request_service_installation':          'Solicitar instalación de servicio',
    'btn.add_service':                           'Añadir servicio',
    'btn.add':                                   'Añadir',
    'btn.remove':                                'Borrar',
    'btn.terminateResource':                     'Terminar recurso',
    'btn.page':                                  'Página',
    'btn.add_issue':                             'Añadir incidencia',
    'btn.cancel_issue':                          'Cancelar incidencia',
    'btn.reactiveIssue':                         'Reactivar incidencia',
    'btn.reopenIssue':                           'Reabrir incidencia',
    'btn.submit_issue':                          'Enviar incidencia',
    'btn.submit_button':                         'Enviar',
    'btn.closeIssue':                            'Cerrar incidencia',
    'placeholder.search_issues':                 'Nombre, id, descripción...',
    'placeholder.search_requests':               'Nombre, id, descripción...',
    'label.select_level':                        'Seleccione el nivel',
    'label.select_project':                      'Seleccione el proyecto',
    'label.edit':                                'Editar',
    'label.person_commented_ago':                '{person} comentó {ago}',
    'label.active_projects':                     'Proyectos activos',
    'label.closed_projects':                     'Proyectos cerrados',
    'label.any_status':                          'Cualquier estado',
    'placeholder.search_projects':               'Nombre, descripción...',
    'placeholder.projects.search':               'Nombre del proyecto...',
    'label.all_customers':                       'Todos los clientes',
    'label.close':                               'Cerrar',
    'label.all_consultants':                     'Todos los consultores',
    'form.issue.title.label':                    'Título',
    'form.issue.title.placeholder':              'Breve y conciso, responda a ¿Cuál es el problema?" o "¿Qué hay que hacer?"',
    'form.issue.title.placeholder.mobile':       '"¿Cuál es el problema?" o "¿Qué hay que hacer?',
    'form.issue.title.error.is_required':        'Por favor, escriba un título para la incidencia',
    'form.issue.title.error.must_be_max_length': 'El título no debe sobrepasar los 30 caracteres',
    'form.validation.must_be_min_length':        'El campo debe tener al menos {min} caracteres',

    'form.validation.must_contain_uppercase':           'El campo debe contener al menos un caracter en mayúsculas',
    'form.validation.must_contain_lowercase':           'El campo debe contener al menos un caracter en minúsculas',
    'form.validation.must_contain_numbers':             'El campo debe contener al menos un número',
    'form.validation.must_contain_special_character':   'El campo debe contener al menos un caracter especial ',
    'form.issue.callerId.modal.label':                  'Solicitante',
    'form.issue.callerId.placeholder':                  'Seleccione un solicitante',
    'form.issue.callerId.modal.title':                  'Seleccione un solicitante',
    'form.issue.callerId.modal.selected.callerid':      'Solicitante seleccionado',
    'form.issue.company.label':                         'Compañía',
    'form.issue.company.placeholder':                   'Seleccione una compañía',
    'form.issue.impact.label':                          'Impacto',
    'form.issue.impact.placeholder':                    'Impacto',
    'form.issue.comment.label':                         'Comentario',
    'form.issue.comment.placeholder':                   'Describir la incidencia tan en detalle como desee.',
    'form.issue.comment.error.is_required':             'Por favor, ingrese un comentario',
    'form.issue.service_offering.label':                'Servicio ofrecido',
    'form.issue.service_offering.placeholder':          'Por favor, indique el servicio ofrecido',
    'form.issue.service_offering.placeholder.disable':  'Seleccione una cuenta y un solicitante',
    'form.issue.service_offering.modal.title':          'Servicio ofrecido',
    'form.issue.service_offering.modal.selecteduser':   'Servicio ofrecido seleccionado',
    'form.issue.id_ticket_customer.label':              'ID del ticket de cliente',
    'form.issue.id_ticket_customer.placeholder':        'ID del ticket de cliente',
    'form.issue.service_now_users.label':               'Lista de vigilancia',
    'form.issue.service_now_users.placeholder':         'Seleccione los usarios para añadir a la lista de vigilancia',
    'form.issue.service_now_users.modal.title':         'Seleccione los usarios para añadir a la lista de vigilancia',
    'form.issue.service_now_users.placeholder.mobile':  'Seleccione los usarios para añadir a la lista de vigilancia',
    'form.issue.service_now_users.modal.selectedusers': 'Usuarios seleccionados',
    'form.issue.service_offering.help':                 '¿Cómo de importante es resolver esta incidencia?',
    'form.issue.service_offering.error.empty':          'Por favor, indique el servicio ofrecido',
    'form.issue.watchList.modal.selecteduser':          'Usuarios seleccionados',
    'form.issue.customer_project.label':                'Proyecto',
    'form.issue.customer_project.help':                 '¿Con qué proyecto se relaciona esta incidencia?',
    'form.issue.customer_project.error.is_required':    'Por favor, indique el proyecto',
    'form.issue.submit':                                'Guardar y seguir',
    'form.request.submit':                              'Guardar y seguir',
    'form.request.title.placeholder':                   'Breve y conciso, responda a "¿Qué necesita?"',
    'form.request.title.placeholder.mobile':            'Descripción breve',
    'form.request.comment.placeholder':                 'Describa la petición con tanto detalle como desee.',
    'label.person_opened_issue_issue':                  '{person} abrió la incidencia {issue}',
    'label.person_opened_task_task':                    '{person} abrió la tarea “{task}”',
    'label.person_closed_task_task':                    '{person} cerró la tarea “{task}”',
    'label.task_completed_in_hours':                    'Completada en {hours, plural, one {# hora} other {# horas}}',
    'label.not_assigned':                               'No asignado',
    'label.service_offering':                           'Servicio ofrecido',

    // Reservations
    'label.active':                    'Activa',
    'label.retired':                   'Retirada',
    'label.all_regions':               'Todas las regiones',
    'label.regions':                   'Regiones',
    'label.all_instance_types':        'Todos los tipos de instancia',
    'label.instance_type':             'Tipo de instancia',
    'label.all_products':              'Todos los productos',
    'label.products':                  'Productos',
    'placeholder.search_reservations': 'ID de la reserva de AWS',
    'title.reservation_id':            'ID de la reserva de AWS',
    'title.product':                   'Producto',
    'title.account':                   'Cuenta',
    'title.region':                    'Región',
    'title.instance_type':             'Tipo de instancia',
    'title.quantity_abbr':             'Cant.',
    'title.quantity':                  'Cantidad',
    'title.accounts':                  'Cuentas',
    'title.all_accounts':              'Todas las cuentas',
    'label.select_item_for_detail':    'Seleccione un ítem de la lista\npara ver el detalle.',
    'btn.retire_reservation':          'Eliminar la reserva de AWS',
    'title.usage_last_10_days':        'Uso en los últimos 10 días',
    'title.account_name':              'Nombre de la cuenta',
    'title.offering_type':             'Tipo de oferta',
    'title.instance_count':            'Cant. instancias',
    'title.start_date':                'Fecha de inicio',
    'title.end_date':                  'Fecha de fin',
    'title.last_update':               'Última actualización',
    'label.date_at_time':              '{date} a las {time}',
    'entity.reservations.singular':    'Reserva de AWS',
    'entity.reservations.plural':      'Reservas de AWS',

    // User
    'msg.you_have_no_accounts':                                    'No hay cuentas.',
    'msg.you_dont_have_credentials_to_discover':                   'No tiene credenciales para lanzar el proceso de descubrir recursos.',
    'msg.need_discover':                                           'El proceso de descubrir recursos no ha sido lanzado aún.',
    'title.add_credential_now':                                    'Agregar una credencial',
    'title.account_id':                                            'ID de la cuenta',
    'title.tags':                                                  'Etiquetas',
    'title.edit_account_acctname':                                 'Editar cuenta "{acctname}"',
    'title.new_account':                                           'Nueva cuenta',
    'title.new_credential':                                        'Nueva credencial',
    'btn.save_changes':                                            'Guardar cambios',
    'btn.add_account':                                             'Agregar cuenta',
    'btn.cancel':                                                  'Cancelar',
    'btn.back':                                                    'Volver',
    'form.account.submit':                                         'Guardar y quedarse',
    'form.account.name.label':                                     'Nombre de la cuenta',
    'form.account.name.help':                                      'El nombre completo de la cuenta',
    'form.account.name.error.is_required':                         'Por favor, ingrese un nombre para la cuenta',
    'form.account.vendor.label':                                   'Proveedor',
    'form.account.account_id.label':                               'ID de la cuenta',
    'form.account.account_id.help':                                'Número de cuenta de AWS',
    'form.account.account_id.error.is_required':                   'Por favor ingrese un ID',
    'form.account.azure_csp.customerId.label':                     'ID de cliente',
    'form.account.azure.currency.label':                           'ISO moneda',
    'form.account.azure.currency.placeholder':                     'EUR, USD, etc.',
    'form.account.azure.purchased.label':                          'ISO del país de la oferta de compra',
    'form.account.azure.offer.label':                              'ID del plan de contratado',
    'form.account.azure.offer.placeholder':                        'Ej: ms-azr-0025p',
    'form.account.azure.locale.label':                             'Idioma (ISO 639-1. Ej: es-ES)', //no hay traduccion y no coincide con la version en inglés
    'form.account.azure.locale.placeholder':                       'Ej: es-ES',
    'form.account.azure_csp.id.label':                             'ID de subscripción',
    'form.account.aws.id.label':                                   'Número de cuenta de AWS',
    'form.account.alicloud.id.label':                              'Número de cuenta de Ali Cloud',
    'form.account.gcloud.id.label':                                'Número de cuenta de Google Cloud',
    'form.account.oracle.id.label':                                'Número de cuenta de Oracle Cloud',
    'form.account.oracle.id.placeholder':                          'Ej: cacct-a1bt67f3bn17a1ytc1drt598a06b32a2',
    'form.account.oracle.identityId.label':                        'Identity Service ID',
    'form.account.oracle.identityId.placeholder':                  'Ej: idcs-arf67vf3abjn012f88d12098pq6b32a3',
    'form.account.aws.id.placeholder':                             'Formato: 12345678901',
    'form.account.alicloud.id.placeholder':                        'Formato: 12345678901',
    'form.account.google.id.placeholder':                          'Formato: 1111AA-11B11A-112223',
    'msg.you_sure_delete_credential':                              '¿Está seguro de que quiere eliminar esta credencial?',
    'msg.credential_already_exists':                               'Ya existe una credencial para esta cuenta y este servicio.',
    'btn.add_credential':                                          'Agregar credencial',
    'msg.you_have_no_credentials':                                 'No hay credenciales. ¿Agregar una?',
    'securityCredential.alias':                                    'Nombre',
    'securityCredential.vendor':                                   'Proveedor',
    'table.securityCredential.alias':                              'Nombre',
    'table.securityCredential.service':                            'Servicio',
    'table.securityCredential.account':                            'Cuenta',
    'table.securityCredential.vendor':                             'Proveedor',
    'title.add_credential':                                        'Agregue una credencial de seguridad',
    'form.securityCredential.alias.label':                         'Alias',
    'form.securityCredential.alias.help':                          'Un alias para su referencia',
    'form.securityCredential.alias.error.is_required':             'Por favor, ingrese un alias',
    'form.securityCredential.alias.error.must_be_max_length':      'El alias es demasiado largo (máx. 50)',
    'form.securityCredential.account.label':                       'Cuenta',
    'form.securityCredential.account.id.label':                    'Número de cuenta',
    'form.securityCredential.account.help':                        'La cuenta de AWS a la que pertenece la credencial',
    'form.securityCredential.account.error.is_required':           'Por favor, ingrese la cuenta',
    'form.securityCredential.service.label':                       'Servicio',
    'form.securityCredential.service.help':                        'Para qué servicio de AWS es esta clave',
    'form.securityCredential.service.error.is_required':           'Por favor, seleccione un servicio',
    'form.securityCredential.access_key.label':                    'Clave de acceso (access key)',
    'form.securityCredential.access_key.error.is_required':        'Por favor, escriba la clave de acceso',
    'form.securityCredential.access_key.error.must_be_max_length': 'La clave es demasiado larga (máx. 20)',
    'placeholder.select_account':                                  'Escoja una cuenta',
    'placeholder.select_service':                                  'Escoja un servicio',
    'label.superuser':                                             'superusuario',
    'label.staff':                                                 'personal',
    'label.consultant':                                            'consultor',
    'label.inactive':                                              'inactivo',
    'title.username':                                              'Nombre de usuario',
    'title.password':                                              'Contraseña',
    'title.password_confirm':                                      'Confirmar contraseña',
    'title.email':                                                 'E-mail',
    'title.last_login':                                            'Último ingreso',
    'login.token_invalid':                                         'La petición de cambio de contraseña ha caducado.',
    'login.invalid_password':                                      'Por favor, verifique que sus contraseñas sean idénticas.',
    'login.empty_password':                                        'Por favor, verifique que los campos no estén vacíos.',
    'login.bad_request':                                           'No se ha podido conectar, compruebe que está conectado a internet.',
    'login.back_to_login':                                         'Volver a la página de registro',
    'title.language':                                              'Idioma',
    'label.change':                                                'cambiar',
    'title.profile':                                               'Perfil',
    'title.credentials':                                           'Credenciales',
    'title.sign_out':                                              'Salir',
    'msg.no_new_notifications':                                    'No tiene notificaciones nuevas',
    'msg.remove_credential_ok':                                    'La credencial {credential} ha sido borrada correctamente',

    // reports
    'title.by_vendor':             'Por Proveedor',
    'title.by_account':            'Por Cuenta',
    'title.by_cost_center':        'Por Proyectos',
    'reports.button.closeTab':     'Cerrar pestaña',
    'reports.button.closeAllTabs': 'Cerrar todas las pestañas',
    'help.reports.search':         'Buscar por elemento',
    'reports.search.cost_center':  'Filtrar por proyecto',
    'reports.search.vendor':       'Filtrar por proveedor',
    'reports.search.account':      'Filtrar por cuentas',
    'btn.print':                   'Imprimir',
    'btn.show_all':                'Mostrar todos',

    //Resources
    'label.resources.vendor':        'Proveedor',
    'label.resources.resourceType':  'Tipo de recurso',
    'label.resources.group':         'Grupo',
    'label.resources.region':        'Región',
    'label.resources.status':        'Estado',
    'label.resources.lastUpdate':    'Última actualización',
    'label.resources.account':       'Cuenta',
    'label.resources.resourceGroup': 'Grupo del recurso',
    'label.resources.resource':      'Recurso',
    'label.resources.id':            'ID',
    'label.resources.instanceType':  'Tipo de instancia',
    'label.resources.services':      'Tienda',
    'label.resources.msp':           'MSP',
    'label.resources.service':       'Servicio',
    'label.resources.version':       'Versión',
    'label.resources.description':   'Descripción',
    'label.resources.errorMessage':  'No tiene conexión a internet o no se puede conectar con el servidor. Por favor, intente de nuevo en unos minutos.',
    'label.resources.instanceUsage': 'Uso de la instancia',
    'label.resources.mac_address':   'Dirección MAC',
    'label.resources.private_ip':    'IP Privada',
    'label.resources.public_ip':     'IP Publica',
    'label.resources.cpuUsage':      'Uso de CPU',
    'label.resources.cpu':           'CPU',
    'label.resources.size':          'Tamaño',
    'label.resources.mountpoint':    'Directorio',
    'label.resources.task':          'Tarea',
    'label.resources.error':         'Error',
    'label.resources.showMore':      'Ver más',
    'label.resources.textLink':      'Desde Cloudmas y AWS nos comprometemos con nuestros clientes a mantener el servicio continuo y seguridad de los servicios prestados a nuestros clientes. Más información en el siguiente link ##link##',
    'label.resources.link':          'aquí',

    'msg.operationDiscover.STATUS_QUEUED':        'Verificando la configuración del servicio de descubrir recursos',
    'msg.operationDiscover.STATUS_LAUNCHED':      'Lanzando tareas. Esta operación puede llevar varios minutos. Por favor, vuelva en unos minutos para comprobar estos recursos',
    'msg.operationDiscover.STATUS_SUCCESS':       'Los recursos han sido encontrados. Puede visualizarlos en la siguiente tabla.',
    'msg.operationDiscover.STATUS_FAIL':          'Ha ocurrido un error',
    'msg.operationDiscover.STATUS_UNKNOWN':       'Ha ocurrido un error',
    'msg.operationDiscover.STATUS_AWS_FAILED':    'Ocurrió un problema al intentar guardar los recursos de AWS, verifique sus credenciales',
    'msg.operationDiscover.STATUS_AZURE_FAILED':  'Ocurrió un problema al intentar guardar los recursos de Azure, verifique sus credenciales',
    'msg.operationDiscover.STATUS_VCLOUD_FAILED': 'Ocurrió un problema al intentar guardar los recursos de VCLOUD, verifique sus credenciales',

    // AWS Reservations
    'label.reservations.id':           'ID de la reserva de AWS',
    'label.reservations.product':      'Producto',
    'label.reservations.account':      'Cuenta',
    'label.reservations.region':       'Región',
    'label.reservations.instanceType': 'Tipo de instancia',
    'label.reservations.qty':          'Cantidad',
    'label.reservations.state':        'Estado',
    'label.reservations.startDate':    'Fecha de inicio',
    'label.reservations.endDate':      'Fecha final',
    'label.reservations.offeringType': 'Opción de pago',
    'label.reservations.stopped':      'Retirada',
    'label.reservations.active':       'Activada',
    'label.reservations.duration':     'Duración',

    // Reservations plurals
    'time.year.one':   'año',
    'time.month.one':  'mes',
    'time.week.one':   'semana',
    'time.day.one':    'día',
    'time.hour.one':   'hora',
    'time.minute.one': 'minuto',
    'time.second.one': 'segundo',

    'time.year.other':   'años',
    'time.month.other':  'meses',
    'time.week.other':   'semanas',
    'time.day.other':    'días',
    'time.hour.other':   'horas',
    'time.minute.other': 'minutos',
    'time.second.other': 'segundos',

    'dropdown.clear': 'Limpiar',

    'title.resources.installed_services':          'Servicios instalados',
    'title.resources.associated_managed_services': 'Servicios gestionados asociados',

    'label.status.0': 'Terminado',
    'label.status.1': 'Activo',
    'label.status.2': 'Detenido',
    'label.status.3': 'Desconocido',
    'label.status.4': 'Esperando',
    'label.status.5': 'Alerta',

    //IaaS Dashboard
    'iaas.topwidget.cpu.title':     'CPU',
    'iaas.topwidget.ram.title':     'RAM',
    'iaas.topwidget.storage.title': 'Almacenamiento',
    'iaas.topwidget.vm.title':      'Máquinas Virtuales',
    'iaas.esx.title':               'Datos del hipervisor',
    'iaas.esx.select.message':      'Seleccione un hipervisor',
    'iaas.search':                  'Buscar...',
    'api.error':                    'Error en la API',
    'title.alert.api':              'API',
    'iaas.cta':                     'Obtén más recursos',
    'iaas.current.vm':              'Máquinas virtuales actuales',
    virtualMachines:                'Máquinas virtuales',
    inUse:                          'En uso',
    vmLast12Header:                 'Máquinas virtuales últimos 12 meses',
    totalVirtualMachines:           'Total de máquinas virtuales',
    vmName:                         'Máquina Virtual',
    statusVm:                       'Estado',
    cpuVm:                          'CPU',
    ramVm:                          'RAM',
    storageVm:                      'Storage',
    activeVm:                       'Encendido',
    inactiveVm:                     'Apagado',
    vdcClient:                      'VDC',
    guestOs:                        'Sistema Operativo',
    selectGuestOs:                  'Seleccione Sistema Operativo',
    selectVCenter:                  'Seleccione VCenter',
    selectVdcClient:                'Seleccione VDC',
    selectCluster:                  'Seleccione cluster',
    selectHypervisor:               'Seleccione hipervisor',
    selectItemsPerPage:             'Elementos por página',
    'iaas.modal.title':             '¿Necesitas más recursos?',
    'iaas.modal.subTitle':          'Hola',
    'iaas.modal.content':           'Para solicitar información sobre este servicio o ampliar los recursos contratados, por favor comuníquese con el Account Executive que tiene asignado o escribe un correo a la siguiente dirección:',
    'extra.information.iaas':       '* Estos datos se adquieren de la última medición del mes',
    'alert.information.iaas':       'Información basada únicamente en los consumos',

    // ITSM Dashboard
    'itsm.tickets.by.state':        'Tickets por estado',
    'itsm.state':                   'Estado',
    'itsm.number':                  'Número',
    'itsm.type':                    'Tipo',
    'itsm.urgency':                 'Urgencia',
    'itsm.impact':                  'Impacto',
    'itsm.opened':                  'Abierto',
    'itsm.closed':                  'Cerrado',
    'itsm.responseTime':            'Respuesta (min)',
    'itsm.resolutionTime':          'Resolución (hr)',
    'itsm.lastUpdate':              'Última actualización',
    'itsm.openedBy':                'Abierto por',
    'itsm.shortDescription':        'Breve descripción',
    'itsm.selectState':             'Seleccione Estado',
    'itsm.selectType':              'Seleccione Tipo',
    'itsm.trouble':                 'Incidencia',
    'itsm.servicerequest':          'Solicitud de servicio',
    'itsm.troublebyimpact':         'Incidencia por impacto  en el mes actual',
    'itsm.servicerequestbyurgency': 'Solicitud de servicio por urgencia en el mes actual',
    'alert.information.itsm':       'Datos solamente para consultas. Si necesitas gestionar tickets, por favor acceder al Portal ECP ',
    'itsm.impact.p1.legend':        'Afecta a un número alto de usuarios, interrumpe el negocio o afecta a la prestación de servicio',
    'itsm.impact.p2.legend':        'Afecta a un grupo de usuarios o interrumpe el negocio con alguna afectación',
    'itsm.impact.p3.legend':        'Usuarios y negocios están impactados pero no interrupidos',
    'itsm.urgency.p1.legend':       'Si la solicitud no se trata, un servicio o sistema puede verse impactado',
    'itsm.urgency.p2.legend':       'Si la solicitud no se trata, un servicio o sistema puede verse impactado',
    'itsm.urgency.p3.legend':       'La petición puede ser planificada para su ejecución. Existe un impacto bajo en el servicio',

    // InfrastructureResourceShowTechnicalDetail
    'label.technicalDetails.title':            'Detalles Técnicos',
    'label.technicalDetails.networks':         'Redes',
    'label.technicalDetails.instance_details': 'Detalles de la instancia',
    'label.technicalDetails.mac_address':      'Dirección MAC',
    'label.technicalDetails.private_ip':       'IP privada',
    'label.technicalDetails.public_ip':        'IP pública',
    'label.technicalDetails.volumes':          'Volúmenes',
    'label.technicalDetails.operation_logs':   'Registros',
    'label.technicalDetails.size':             'Tamaño',
    'label.technicalDetails.id':               'ID',
    'label.technicalDetails.nodata':           'Sin datos',
    'label.technicalDetails.internetUse':      'Uso de internet',
    'dropdown.internetUse.port1':              'Puerto 1',
    'dropdown.internetUse.port2':              'Puerto 2',
    'dropdown.internetUse.allports':           'Todos los puertos',
    'label.technicalDetails.bandWidth':        'Ancho de banda',
    'label.technicalDetails.port':             'Puerto',
    'label.technicalDetails.redundancy':       'Redundancia',
    'label.technicalDetails.ips':              'IP\'s',
    'label.technicalDetails.nic_name':         'Nombre de NIC',

    'label.security_credentials.accounts':        'Cuentas',
    'label.security_credentials.credentials':     'Credenciales de {account}',
    'label.security_credentials.accounts_vendor': 'Cuentas de {vendor}',

    'resource.action.start': 'El recurso está pendiente para ser iniciado.',
    'resource.action.stop':  'El recurso está pendiente para ser detenido.',

    'table.msg_no_data': 'No hay datos.',

    'chart.products.others':             'Otros',
    'report.title.spendingbreakdown':    'Desglose de consumos',
    'report.subtitle.spendingbreakdown': 'Producto desglosado por {concept}',
    'report.series.vendors':             'Proveedores',
    'report.series.accounts':            'Cuentas',
    'report.series.products':            'Productos',
    'report.series.cost_center':         'Proyectos',
    'report.series.regions':             'Regiones',
    'report.series.drilluptext':         'Regresar a {series}',
    'report.table.name':                 'Nombre',
    'report.table.totalcosts':           'Coste total',
    'report.table.total':                'TOTAL',
    'report.table.footer':               'Coste estimado desde {start} hasta {end}',
    'report.spending.vendor':            'proveedor',
    'report.spending.cost_center':       'proyecto',
    'report.spending.account':           'cuenta',
    'report.spending.usage':             'Uso',
    'report.spending.total':             'Total',

    'dashboard.breakdown.account':                  'Por cuenta',
    'dashboard.breakdown.vendor':                   'Por proveedor',
    'dashboard.breakdown.productArea':              'Por área de producto',
    'dashboard.breakdown.costCenter':               'Por proyecto',
    'dashboard.spending12.title':                   'Consumo en los últimos 12 meses',
    'dashboard.breakdown.title':                    'Consumo diario',
    'dashboard.breakdown.total':                    'Gasto total del periodo',
    'dashboard.breakdown.prev':                     'Mes anterior',
    'dashboard.breakdown.change':                   'Diferencia',
    'dashboard.breakdown.footer':                   'Valores redondeados al dolar más cercano.',
    'dashboard.topwidget.product_area.title':       'Áreas de productos con más gastos',
    'dashboard.topwidget.cost_center.title':        'Proyectos con más gastos',
    'dashboard.topwidget.account.title':            'Cuentas con más gastos',
    'dashboard.topwidget.show.chart':               'Mostrar gráfico',
    'dashboard.topwidget.hide.chart':               'Ocultar gráfico',
    'dashboard.topwidget.predictions.title':        'Previsión de gasto por proveedor del mes en curso',
    'label.topwidget.table.name':                   'Nombre',
    'label.topwidget.table.total_costs':            'Coste total',
    'label.topwidget.table.prediction.name':        'Proveedor',
    'label.topwidget.table.prediction.total_costs': 'Previsión',

    'label.notavailable':   'N/D',
    'label.type_to_search': 'Escriba para buscar',

    // Hired Products
    'label.hired.products.title':              'Productos contratados',
    'label.hired.products.asset_desc':         'Producto',
    'label.hired.products.asset_id':           'ID del activo',
    'label.hired.products.product_id':         'ID del producto',
    'label.hired.products.desc_element':       'Descripción de activo',
    'label.hired.products.tier':               'Tier',
    'label.hired.products.iops':               'IOPS',
    'label.hired.products.uom':                'UOM',
    'label.hired.products.type':               'Tipo',
    'label.hired.products.volume':             'Volumen (GB)',
    'label.hired.products.quantity':           'Cantidad',
    'label.hired.products.consumption':        'Consumo',
    'label.hired.products.comercial_model':    'Modo comercial',
    'label.hired.products.backup_retention':   'Protección de backup',
    'label.hired.products.typr_of_monitoring': 'Tipo de monitorización',

    // Consultancy
    'label.issues.createUser':           'Creado por',
    'label.issues.incident':             'Incidencia',
    'label.requests.request':            'Petición',
    'label.issues.company':              'Compañía',
    'label.issues.comments':             'Comentarios',
    'label.issues.title':                'Título',
    'label.issues.priority':             'Prioridad',
    'label.issues.tag_state':            'Estado',
    'label.issues.datetime':             'Fecha',
    'label.issues.openedAt':             'Abierto',
    'label.issues.account_name':         'Cuenta',
    'label.issues.totalMessages':        'Número de mensajes',
    'label.issues.created_message':      'Creado por ##creationUserName## el ##date## (##dateMessage##)',
    'label.issues.activityComments':     '##totalMessages## ##formatTotalMessage##',
    'label.issues.singularComment':      'comentario',
    'label.issues.pluralComment':        'comentarios',
    'label.issues.assignedToTooltip':    'Asignado a ##responsibleUser.name##',
    'label.issues.createdPersonTooltip': 'Creado por ##creationUserName##',
    'label.issues.requester':            'Solicitante',
    'label.issues.status':               'Estado',
    'label.issues.level':                'Nivel',
    'label.issues.assignedTo':           'Responsable',
    'label.issues.openedBy':             'Abierto por:',
    'label.issues.closedBy':             'cerró el ticket',
    'label.issues.commented':            'comentó',
    'label.issues.comment':              'Agregar un comentario',
    'label.issues.impact':               'Impacto',
    'label.issues.description':          'Descripción',
    'label.all_issues_status':           'Cualquier status',
    'label.issues_status':               'Status',
    'label.all_priorities':              'Todas las pioridades',
    'label.priority':                    'Prioridad',
    'label.issues.status.1':             'Abierto',
    'label.issues.status.2':             'En curso',
    'label.issues.status.3':             'Completamente cerrado',
    'label.issues.status.4':             'Incompletamente cerrado',
    'label.issues.status.-5':            'Pendiente',
    'label.issues.status.7':             'Cerrado por omisión',
    'label.issues.status.500':           'Reintento cerrado',
    'label.issues.status.501':           'Continuación cerrada',
    'label.issues.status.502':           'Anulación cerrada',

    //Plans
    'title.jobplans':             'Tareas / Planes',
    'title.backups':              'Backup',
    'backups.perday':             'Copias de seguridad por dia',
    'title.plans':                'Planes',
    'label.plans.name':           'Nombre',
    'label.plans.schedule':       'Calendario',
    'label.plans.next_run':       'Próxima ejecución',
    'label.plans.last_run':       'Última ejecución',
    'label.plans.enable':         'Activo',
    'placeholder.search_plans':   'Nombre...',
    'label.all_schedules':        'Todas las recurrencias',
    'label.schedules':            'Recurrencias',
    'btn.add_plan':               'Añadir plan',
    'btn.remove_plan':            'Quitar plan',
    'label.select_plans':         'Seleccione los planes',
    'entity.plans.singular':      'plan',
    'entity.plans.plural':        'planes',
    'label.enable':               'Activo',
    'label.disable':              'Inactivo',
    'template.undefined':         'por definir',
    'template.plans.now':         'Inmediatamente',
    'template.plans.once':        'Una sola vez el ##date## a ##time##',
    'template.plans.every':       'Todos los días a ##time## desde ##start## hasta ##end##',
    'template.plans.every-never': 'Todos los días a ##time## desde ##start##',
    'template.plans.week':        'Todos los ##dayWeek## a ##time## desde ##start## hasta ##end##',
    'template.plans.week-never':  'Todos los ##dayWeek## a ##time## desde ##start##',
    'template.plans.month':       'Todos los ##dayMonth## de cada mes a ##time## desde ##start## hasta ##end##',
    'template.plans.month-never': 'Todos los ##dayMonth## de cada mes a ##time## desde ##start##',
    'dropdown.schedules.once':    'Una sola vez',
    'dropdown.schedules.every':   'A diario',
    'dropdown.schedules.week':    'Semanal',
    'dropdown.schedules.month':   'Mensual',
    'label.execution.success':    'correcto',
    'label.execution.queued':     'encolado',
    'label.execution.launched':   'lanzado',
    'label.execution.failed':     'fallado',
    'label.execution.unknown':    'desconocido',

    'label.dropdown.type.month': 'Mes ',
    'label.dropdown.type.date':  'Día ',

    //Customer Service Center
    'title.csc':                    'CSC',
    'title.contacts':               'Contactos',
    'title.contacts_new':           'Nuevo contacto',
    'btn.add_contact':              'Nuevo contacto',
    'btn.remove_contact':           'Eliminar contacto',
    'label.contacts.id':            'ID de cliente',
    'label.contacts.customer':      'Cliente',
    'label.contacts.contact':       'Contacto',
    'label.contacts.roles':         'Roles',
    'label.contacts.dni':           'ID / DNI',
    'label.contacts.buildings':     'Edificio',
    'label.contact.edit':           'Editar contacto',
    'placeholder.search_contacts':  'ID, Nombre, Apellidos, Teléfono, E-mail, DNI',
    'label.all_roles':              'Roles: todos',
    'label.roles':                  'Roles',
    'label.all_buildings':          'Edificios: todos',
    'label.buildings':              'Edificios',
    'label.select_contacts':        'Seleccione contactos',
    'form.contact.fullName.label':  'Nombre y apellidos',
    'form.contact.fullName.help':   'Nombre y apellidos',
    'form.contact.phone.label':     'Teléfono',
    'form.contact.phone.help':      'Teléfono',
    'form.contact.email.label':     'E-mail',
    'form.contact.email.help':      'E-mail',
    'form.contact.dni.label':       'DNI',
    'form.contact.dni.help':        'DNI',
    'form.contact.roles.label':     'Roles',
    'form.contact.buildings.label': 'Edificios',
    'form.contact.id.label':        'ID de cliente',
    'form.contact.shortName.label': 'Nombre del cliente',
    'form.contact.details.label':   'Detalles del contacto',
    'form.contact.submit':          'Guardar y seguir',
    'table.contact.roles.code':     'Código del rol',
    'table.contact.roles.name':     'Nombre del rol',

    // Plurals
    'label.comments.one':  'comentario',
    'label.comments.many': 'comentarios',

    'form.validation.must_be_max_length': 'No puede tener más de {maxlength} caracteres',
    'form.validation.empty':              'No puede estar vacio',
    'form.validation.do_no_match':        'Debe ser igual a \'{field}\'',
    'form.validation.invalid_exp':        'Debe cumplir el patrón \'{pattern}\'',
    'form.default.submit':                'Guardar y seguir',
    'form.default.reset':                 'Limpiar',
    'form.default.cancel':                'Cancelar',
    'form.default.saveAddAnother':        'Guardar y agregar otro',
    'form.default.saveAndStayText':       'Guardar y quedarse',
    'form.remove':                        'Borrar',
    'form.close':                         'Cerrar',
    'form.logDetails':                    'Detalles del registro',
    'form.default.save':                  'Guardar y volver',
    'info.file_input.max':                'Número máximo de archivos a adjuntar: {max}',
    'info.file_input.size':               'Tamaño máximo de cada archivo a adjuntar: {max}',

    'label.accounts.vendor':       'Proveedor',
    'label.accounts.name':         'Nombre de la cuenta',
    'placeholder.search_accounts': 'Nombre...',

    'form.credential.alias.label':                           'Alias',
    'form.credential.id.label':                              'ID de la cuenta',
    'form.credential.account.label':                         'Cuenta',
    'form.credential.service.label':                         'Servicio',
    'form.credential.aws.secret.label':                      'Clave de acceso secreta',
    'form.credential.aws.secret.change.label':               'Cambiar clave de acceso secreta',
    'form.credential.aws.secret.change.placeholder':         'Nueva clave de acceso secreta',
    'form.credential.aws.access.label':                      'Clave de acceso',
    'form.credential.alicloud.secret.label':                 'Clave de acceso secreta',
    'form.credential.alicloud.secret.change.label':          'Cambiar clave de acceso secreta',
    'form.credential.alicloud.secret.change.placeholder':    'Nueva clave de acceso secreta',
    'form.credential.alicloud.access.label':                 'Clave de acceso',
    'form.credential.azure.clientId.label':                  'ID de la aplicación',
    'form.credential.azure.clientSecret.label':              'Clave de acceso secreta',
    'form.credential.azure.clientSecret.change.label':       'Cambiar clave de acceso secreta',
    'form.credential.azure.clientSecret.change.placeholder': 'Nueva clave de acceso secreta',
    'form.credential.azure.tenant.label':                    'ID del directorio',
    'form.credential.azure.subscription.label':              'Cuenta',
    'form.credential.vcloud.username.label':                 'Usuario',
    'form.credential.vcloud.password.label':                 'Contraseña',
    'form.credential.vcloud.password.change.label':          'Cambiar contraseña',
    'form.credential.vcloud.password.placeholder':           'Nueva contraseña',
    'form.credential.vcloud.host.label':                     'Host',
    'form.credential.vcloud.virtualdatacenter.label':        'Centro de datos virtual',
    'form.credential.vcloud.organization.label':             'Organización',
    'form.credential.submit':                                'Guardar y seguir',

    'spinner.loading':  'Cargando...',
    'spinner.updating': 'Actualizando...',
    'spinner.creating': 'Creando...',
    'spinner.deleting': 'Borrando...',
    'spinner.logout':   'Saliendo...',

    // Modals
    'form.terminate.resource': '¿Está seguro de que quiere terminar este recurso?',
    'form.terminate.confirm':  'Por favor, escriba el ID del recurso para terminarlo:',
    'form.terminate.success':  'El recurso será terminado',
    'form.terminate.error':    'El ID es incorrecto',

    // States
    'label.state.pending':    'Pendiente',
    'label.state.running':    'Encendido',
    'label.state.stopped':    'Apagado',
    'label.state.terminated': 'Terminado',
    'label.state.warning':    'Alerta',
    'label.state.unknown':    'Desconocido',

    // Fixes
    'btn.remove_credential':         'Borrar credencial',
    'form.modal.credentials.close':  'No, no quiero',
    'form.modal.credentials.remove': 'Sí, borrar esta credencial',
    'label.reservations.ec2':        'Elastic Compute Cloud',
    'form.modal.remove.message':     '¿Está seguro de que quiere borrar la siguiente credencial?',

    'title.error.authorization':    'Error de autorización',
    'label.error.authorization':    'Lo sentimos, usted no tiene permisos para realizar esta tarea.',
    'label.noDataMessage':          'Lo sentimos, no hay datos',
    'label.noDataAvailableMessage': 'Información en tiempo real no disponible para eventos abiertos anteriores a 2 meses.',

    //Datepicker
    'label.datepicker.changetime': 'Cambiar a hora',
    'label.datepicker.changedate': 'Cambiar a fecha',
    'label.datepicker.clear':      'Limpiar fecha',
    'label.timepicker.clear':      'Limpiar hora',
    'label.msg_no_date':           'Sin fecha',
    'label.msg_no_time':           'Sin hora',
    'btn.ok':                      'Aceptar',
    'btn.rangedate.changestart':   'Cambiar a fecha inicial',
    'btn.rangedate.changeend':     'Cambiar a fecha final',
    'template.rangedate':          '##start## - ##end##',

    // Resources mobile
    'label.resources.mobile.sortBy':       'Ordenar por',
    'label.resources.mobile.instanceName': 'Nombre de instancia',
    'label.resources.mobile.vendor':       'Proveedor',
    'label.resources.mobile.region':       'Región',
    'label.resources.mobile.instanceType': 'Tipo de instancia',
    'label.resources.mobile.showCPULoad':  'Mostrar carga de CPU',
    'label.resources.mobile.hideCPULoad':  'Ocultar carga de CPU',

    // Backups
    'backups.top10host.title':                         'Top 10 políticas por consumo de copias de seguridad',
    'backups.selectHosts.loading':                     'Cargando políticas...',
    'backups.selectHosts.placeholder':                 'Seleccione sus políticas',
    'backups.selectHosts.header':                      'Políticas disponibles',
    'backups.currentMonthPeak':                        'Consumo del mes actual (TB protegido)',
    'backups.previousMonthPeak':                       'Consumo del mes anterior (TB protegido)',
    'backups.previousMonthPercent':                    'Variación respecto al mes anterior',
    'backups.nextEstimation':                          'Estimación para el próximo mes',
    'backups.daily.overall':                           'Suma total',
    'backups.daily.peak':                              'Pico',
    'backups.monthChange':                             'Change since last month',
    'title.backups.mock':                              'Simulacro de copias de seguridad',
    'title.report':                                    'Detalles',
    'label.backups.host':                              'Política',
    'label.backups.period':                            'Fecha de inicio (UTC)',
    'label.backups.periodEnd':                         'Fecha de fin (UTC)',
    'label.backups.duration':                          'Duración',
    'label.backups.size':                              'Tamaño',
    'label.backups.type':                              'Tipo',
    'label.backups.type.FULL':                         'Completo',
    'label.backups.type.INCREMENTAL':                  'Incremental',
    'label.backups.type.DIFFERENTIAL':                 'Diferencial',
    'label.backups.type.ANY_LEVEL':                    'Cualquier nivel',
    'label.backups.type.SYNTHETICFULL':                'Completamente sintético',
    'label.backups.type.TRANS_LOG_NO_TRUNC':           'Trans log no trunc',
    'label.backups.type.ASR':                          'ASR',
    'label.backups.type.OFFLINE_FULL':                 'Completamente offline',
    'label.backups.type.CREATE_SNAPSHOT':              'Crear instantánea',
    'label.backups.type.REPLICATE_CREATE':             'Replicar creación',
    'label.backups.type.REPLICATE_INCREMENTAL_UPDATE': 'Replicar actualización incremental',
    'label.backups.type.ONLINE_FULL':                  'Completamente online',
    'label.backups.type.UNKNOWN':                      'Desconocido',
    'label.backups.info':                              'Info',
    'label.backups.status':                            'Estado',
    'label.backups.status.FAILED':                     'Fallido',
    'label.backups.status.STARTFAILED':                'Error al iniciar',
    'label.backups.status.KILLED':                     'Terminado',
    'label.backups.status.PARTIALSUCCESS':             'Éxito parcial',
    'label.backups.status.SUCCESS':                    'Éxito',
    'label.backups.status.UNKNOWN':                    'Desconocido',
    'label.backups.article':                           'Tipo de servicio',
    'label.backupsMachines.vcenter':                   'VCENTER',
    'label.backupsMachines.vmachine':                  'VM',
    'label.backupsMachines.startDate':                 'Fecha de inicio',
    'label.backupsMachines.endDate':                   'Fecha de fin',
    'label.backupsMachines.duration':                  'Duración',
    'label.backupsMachines.size':                      'Tamaño (Gb)',
    'template.backups.dates':                          'A ##start## (##duration##)',
    'placeholder.search_backups':                      'Política...',
    'btn.exportCSV':                                   'Descargar',
    'backups.contract':                                'Contrato',
    'backups.hostData':                                'Datos del host',
    'backups.labelValue':                              'Tamaño total',
    'backups.top.ten.host.title':                      'Copias de seguridad de mayor tamaño',
    'backups.last13months.chart':                      'Consumos de copias de seguridad de los últimos meses (máx 13)',
    'backups.last13months.months':                     'Meses',
    'extra.information.backups':                       'Una política puede contener más de un dispositivo. Si tiene alguna duda, contacte con su jefe de proyecto.',

    'legend.text.all':         'Mostrar todos',
    'legend.text.reset':       'Reset',
    'legend.text.none':        'Ocultar todos',
    'legend.text.placeholder': 'Filtrar por...',
    'legend.text.header':      'Filtros aplicados',

    'label.mobile.sortBy': 'Ordenar por',

    'status.widget.vendor': 'Proveedor',
    'btn.reset.zoom':       'Reestablecer zoom',
    'status.widget.status': 'Estado',

    //Errors
    'error.VM_NOT_FOUND':               'No tiene permisos para ver esta Vm o la Vm no existe.',
    'error.VENDOR_NOT_MATCH':           'Este proveedor no puede obtener el uso de cpu.',
    'error.INCIDENT_NOT_FOUND':         'No tiene permisos para ver esta incidencia o la incidencia no existe.',
    'error.SERVICE_OFFERING_NOT_FOUND': 'No tiene permisos para ver SERVICE_OFFERING o SERVICE_OFFERING no existe.',
    'error.STATE_NOT_FOUND':            'No tiene permisos para ver STATE o STATE no existe.',
    'error.MISSING_CREDENTIALS':        'No tiene credenciales para este servicio.',
    'error.PERMISSION_DENIED':          'No tiene permisos para este servicio.',
    'error.INVALID_PAYLOAD':            'Los datos enviados son incorrectos.',
    'error.VENDOR_NOT_FOUND':           'Este proveedor no puede obtener el uso de cpu.',
    'error.INVALID_CREDENTIALS':        'Credencial inválida para este servicio.',
    'error.ITEM_NOT_FOUND':             'Item no encontrado.',
    'error.INTERNAL_SERVER_ERROR':      'Hubo un error interno en el servidor.',
    'error.SERVICE_UNAVAILABLE':        'Este servicio no está disponible.',
    'error.FORBIDDEN':                  'No tiene permisos para realizar esta tarea.',
    'error.INVALID_ACCOUNT':            'El formato de la cuenta no es válido.',
    'error.chunk.title':                'Error',
    'error.chunk.text':                 'Hubo un problema cargando esta vista. Por favor, teclee Ctrl+F5 para intentar solucionarlarlo.',

    'label.resources.msp.false': 'No',
    'label.resources.msp.true':  'Sí',

    'label.notifications.removeall': 'Descartar todo',

    'label.filters.mobile.hideButton':  'Ocultar filtros',
    'label.filters.mobile.showFilters': 'Mostrar filtros',
    'label.filters.filtering.message':  'Aplicando filtros  (mostrar)',

    'label.sorted.field.desc': 'Ordenado por {sortFieldName} de forma descendente',
    'label.sorted.field.asc':  'Ordenado por {sortFieldName} de forma ascendente ',

    // Vendor
    'label.gcp':       'Plataforma Google Cloud',
    'label.gcloud':    'Plataforma Google Cloud',
    'label.aws':       'Amazon Web Services',
    'label.azure_csp': 'Microsoft Azure',
    'label.vcloud':    'VCloud',
    'label.itconic':   'Itconic',
    'label.oracle':    'Oracle Cloud',
    'label.alicloud':  'Alibaba Cloud',

    'title.page.alert':  '{alerts} nueva alerta - {title}',
    'title.page.alerts': '{alerts} nuevas alertas - {title}',

    'form.aws_support.account.label':                     'Cuenta',
    'form.aws_support.subject.label':                     'Asunto',
    'form.aws_support.service.label':                     'Servicio',
    'form.aws_support.category.label':                    'Categoría',
    'form.aws_support.severity.label':                    'Severidad',
    'form.aws_support.description.label':                 'Descripción',
    'form.aws_support.cc.label':                          'Lista de emails',
    'form.attachments.button':                            'Adjuntar archivos',
    'form.aws_support.attachments.label':                 'Adjuntos',
    'form.aws_support.attachments.success':               '{filesCount, plural, one {El fichero} other {Los ficheros}} {fileNames} {filesCount, plural, one {fue subido} other {fueron subidos}} correctamente.',
    'form.aws_support.attachments.max_files':             'Está intentado adjuntar {chosen} archivos pero no está permitido adjuntar más de {max}',
    'form.aws_support.attachments.max_size':              'Está intentado adjuntar {name} que tiene {size} pero el máximo permitido es {max}',
    'form.aws_support.attachments.already':               'Está intentado adjuntar {name} que ya fue seleccionado',
    'form.aws_support.comment.label':                     'Comentario',
    'form.aws_support.comment.error.is_required':         'Por favor, introduzca un comentario',
    'placeholder.search_aws_support':                     'ID del caso (sólo uno)',
    'placeholder.aws_support.account':                    'Seleccione la cuenta para ver sus tickets.',
    'label.resolved.on':                                  'Resueltos',
    'label.resolved.off':                                 'No resueltos',
    'label.aws.created':                                  'Creado',
    'label.aws.subject':                                  'Asunto',
    'label.aws.id':                                       'Ticket',
    'label.aws.severity':                                 'Severidad',
    'label.aws.status':                                   'Estado',
    'label.aws.attachments':                              'Adjuntos',
    'label.aws.description':                              'Descripción',
    'label.aws.service':                                  'Servicio',
    'label.aws.category':                                 'Categoría',
    'label.aws.cc':                                       'CC',
    'label.all_status':                                   'Cualquier estado',
    'label.status':                                       'Estado',
    'label.aws.comment':                                  'Agregar un comentario',
    'form.ticket.submit':                                 'Guardar y quedarse',
    'label.aws_support_status.unassigned':                'Sin asignar',
    'label.aws_support_status.opened':                    'Abierta',
    'label.aws_support_status.reopened':                  'Reabierta',
    'label.aws_support_status.work-in-progress':          'Trabajando',
    'label.aws_support_status.pending-customer-action':   'Pendiente de acción del cliente',
    'label.aws_support_status.customer-action-completed': 'Acción del cliente completada',
    'label.aws_support_status.resolved':                  'Resuelta',
    'label.aws_support_severity.low':                     'Baja',
    'label.aws_support_severity.normal':                  'Normal',
    'label.aws_support_severity.high':                    'Alta',
    'label.aws_support_severity.urgent':                  'Urgente',
    'btn.add_support':                                    'Añadir ticket',
    'btn.close_support':                                  'Cerrar ticket',
    'btn.aws_support.showMore':                           'Mostrar más',
    'btn.aws_support.init':                               'Página inicial',
    'template.aws_support.created':                       'Creado por {account} ({accountId}) {date}',

    'label.aws_support.type.billing':   'Facturación',
    'label.aws_support.type.technical': 'Técnico',

    'title.alert.accounts':                     'Cuentas',
    'title.alert.awsAccounts':                  'Cuentas AWS',
    'title.alert.awsCredentials':               'Credenciales AWS',
    'title.alert.awsInstanceTypes':             'Tipos de instancia AWS',
    'title.alert.awsProducts':                  'Productos AWS',
    'title.alert.awsRegions':                   'Regiones AWS',
    'title.alert.awsSupport':                   'Soporte AWS',
    'title.alert.awsSupportBilling':            'Soporte de facturación AWS',
    'title.alert.awsSupportTechnical':          'Soporte técnico AWS',
    'title.alert.azrProducts':                  'Productos Azure',
    'title.alert.azrRegions':                   'Regiones Azure',
    'title.alert.azureAccounts':                'Cuentas Azure',
    'title.alert.azureCredentials':             'Credenciales Azure',
    'title.alert.backupsDaily':                 'Backups diarios',
    'title.alert.backupsHosts':                 'Backups hosts',
    'title.alert.categoriesAwsSupport':         'Categorías de soporte AWS',
    'title.alert.googleAccounts':               'Cuentas Google',
    'title.alert.issues':                       'Incidencias',
    'title.alert.issuesByState':                'Incidencias',
    'title.alert.issueStatuses':                'Estados',
    'title.alert.internetMonthly':              'Tráfico de internet mensual',
    'title.alert.internetDaily':                'Tráfico de internet diario',
    'title.alert.itcProducts':                  'Productos Itconic',
    'title.alert.itcRegions':                   'Regiones Itconic',
    'title.alert.operationLogs':                'Logs de operaciones',
    'title.alert.regions':                      'Regiones',
    'title.alert.reportBackups':                'Informe de backups',
    'title.alert.reportingBackupsHost':         'Informe de backups de hosts',
    'title.alert.reportingLast2MonthsBackups':  'Backups de los últimos 2 meses',
    'title.alert.reportingLast13MonthsBackups': 'Backups de los últimos 13 meses',
    'title.alert.reports':                      'Facturación',
    'title.alert.reservations':                 'Reservas',
    'title.alert.resources':                    'Recursos',
    'title.alert.resourceTypes':                'Tipos de recurso',
    'title.alert.securityCredentials':          'Credenciales de seguridad',
    'title.alert.services':                     'Servicios',
    'title.alert.servicesAwsSupportBilling':    'Servicios de soporte de facturación AWS',
    'title.alert.servicesAwsSupportTechnical':  'Servicios de soporte técnico AWS',
    'title.alert.servicesOffering':             'Servicio ofrecido', //Oferta de servicios?
    'title.alert.severities':                   'Severidad',
    'title.alert.spendingByAccount':            'Gasto por cuenta',
    'title.alert.spendingByCostCenter':         'Gasto por proyecto',
    'title.alert.spendingByProductArea':        'Gasto por área de producto',
    'title.alert.spendingByVendor':             'Gasto por proveedor',
    'title.alert.spendingLastYear':             'Gasto de último año', //Gasto del último año?
    'title.alert.subscriptions':                'Subscripciones',
    'title.alert.tasksState':                   'Estados de tarea',
    'title.alert.tasksTypes':                   'Tipos de tarea',
    'title.alert.topByAccount':                 'Top por cuenta',
    'title.alert.topByCostCenter':              'Top por proyecto',
    'title.alert.topByProductArea':             'Top por área de producto',
    'title.alert.totalSpending':                'Gasto total',
    'title.alert.vcloudAccounts':               'Cuentas Vcloud',
    'title.alert.vcloudCredentials':            'Credenciales Vcloud',
    'title.alert.vendors':                      'Proveedores',
    'title.alert.vmStates':                     'Estados de VM',
    'title.alert.iaasVirtualMachines':          'Máquinas Virtuales',
    'title.alert.alicloudAccounts':             'Cuentas de Alicloud',

    'label.currentMonth': 'Mes actual',

    'form.password.button':     '(Cambiar)',
    'form.password.save':       'Guardar',
    'form.password.old.label':  'Antigua contraseña',
    'form.password.new1.label': 'Nueva contraseña',
    'form.password.new2.label': 'Repita nueva contraseña',
    'form.password.title':      'Cambiar contraseña',
    'form.password.success':    'Contraseña cambiada correctamente',

    'message.noConsume': 'Lo sentimos, todavía no hay informes disponibles',

    'updated.title':                'Aplicación actualizada',
    'updated.ok':                   'Aceptar',
    'update.ok.accept':             'Aceptar y cerrar',
    'updated.text':                 'La aplicación ha sido actualizada. Será recargada para obtener esta actualización.',
    'label.button.showDescription': 'Mostrar descripción',
    'label.button.hideDescription': 'Ocultar descripción',
    'label.description':            'Descripción',

    'add.serviceNowUsers': 'Agregar usuarios para seguir la incidencia',

    // BUTTON States
    'issues.button.reactive':           'Reactivar incidencia',
    'issues.button.reopen':             'Reabrir incidencia',
    'issues.button.cancel':             'Cancelar incidencia',
    'issues.button.cancelDisable':      'Escribe un mensaje para cancelar la incidencia',
    'issues.button.comment':            'Comentar',
    'issues.cancelmodal.title':         'Cancelar incidencia',
    'request.cancelmodal.title':        'Cancelar petición',
    'issues.cancelmodal.body':          '¿Quiere cancelar la incidencia ##issue##?',
    'issues.cancelmodal.button.accept': 'Sí, cancelar la incidencia',
    'issues.cancelmodal.button.cancel': 'No, no quiero',

    // Button Actions
    'button.next':                'Siguiente',
    'button.back':                'Volver',
    'button.securityCredentials': 'Mis credenciales de seguridad',

    // Containers service now
    'label.requesters.label':                            'Nombre',
    'label.requesters.id':                               'ID',
    'label.serviceOffering.label':                       'Servicio',
    'label.serviceOffering.id':                          'ID',
    'label.companyColumn.label':                         'Nombre de la compañía',
    'label.companyTitle':                                'Seleccione la compañía',
    'label.company.selected.title':                      'Compañía seleccionada',
    'button.cancel':                                     'Cancelar',
    'button.accept':                                     'Aceptar',
    'form.issue.impact.default':                         'No hay perdida de servicio',
    'form.request.urgency.default':                      'Baja',
    'label.watchList.comment.placeholder':               'Agrega un email',
    'label.watchList.search':                            'Pulse para buscar un usuario',
    'placeholder.searchServiceNowUser':                  'Buscar por nombre de usuario',
    'placeholder.searchByServiceOffering':               'Buscar por nombre de servicio ofertado',
    'placeholder.searchServiceNowCompany':               'Buscar por nombre de compañía',
    'label.optional.field':                              'opcional',
    'label.watchlist.users':                             'Usuarios en la lista de seguimiento',
    'form.issue.service_offering.modal.serviceOffering': 'Servicio ofrecido seleccionado',
    'label.issues.attachments':                          'Archivos adjuntos',
    'label.issues.attachFiles':                          'Adjuntar archivos',
    'label.button.cancel':                               'Cancelar',

    'label.choose.files':           'Adjuntar archivos',
    'label.uploadState.error':      'Ha habido un error. Por favor, inténtalo de nuevo.',
    'label.uploadState.processing': 'Procesando',
    'label.uploadState.finished':   'Finalizado',
    'label.uploadState.inProgress': 'Completado',
    'label.uploadState.pending':    'Iniciando',

    'label.watchList.nousers': 'No hay usuarios en la lista de seguimiento',

    'label.date.prep':                       'el', //en?
    'label.noAttachedFiles':                 'No hay archivos adjuntos',
    'label.issue.totalAttachments.plural':   'Hay {number} archivos adjuntos',
    'label.issue.totalAttachments.singular': 'Hay {number} archivo adjunto',
    'label.showMore':                        'MOSTRAR MÁS',
    'label.showLess':                        'MOSTRAR MENOS',

    'label.noCustomerTicketIssue': 'Ninguno',

    'table.issues.customerActionNeeded': 'Se necesita la acción del cliente',

    'label.issues.state.open':                 'Abierto',
    'label.issues.state.pending':              'Pendiente',
    'label.issues.state.resolved':             'Resuelto',
    'label.issues.state.closed':               'Cerrado',
    'label.issues.state.customerActionNeeded': 'Se necesita la acción del cliente',
    'label.issues.customerActionNeeded.help':  'Mostrar peticiones pendientes de la acción del cliente',

    'label.issues.state.open.plural':                 'Abiertos',
    'label.issues.state.pending.plural':              'Pendientes',
    'label.issues.state.resolved.plural':             'Resueltos',
    'label.issues.state.closed.plural':               'Cerrados',
    'label.issues.state.customerActionNeeded.plural': 'Se necesita la acción del cliente', //Pendiente de la acción del cliente?

    'label.requests.state.open':                 'Abierta',
    'label.requests.state.pending':              'Pendiente',
    'label.requests.state.resolved':             'Entregada',
    'label.requests.state.closed':               'Cerrada',
    'label.requests.state.customerActionNeeded': 'Se necesita la acción del cliente',
    'label.requests.customerActionNeeded.help':  'Mostrar peticiones pendientes de la acción del cliente',

    'label.requests.state.open.plural':                 'Abiertas',
    'label.requests.state.pending.plural':              'Pendientes',
    'label.requests.state.resolved.plural':             'Entregadas',
    'label.requests.state.closed.plural':               'Cerradas',
    'label.requests.state.customerActionNeeded.plural': 'Se necesita la acción del cliente',

    'label.watchList.help':         'Si quieres compartir la visibilidad de esta incidencia, por favor agrega un email o pulsa el botón para buscar usuarios de su compañía',
    'label.watchList.help.request': 'Si quieres compartir la visibilidad de esta petición, por favor agrega un email o pulsa el botón para buscar usuarios de su compañía',
    'title.alert.attachments':      'Error al subir el archivo',

    //P200
    'title.p200':         'Informe mensual',
    'title.p200.report':  'Reportes',
    'table.col.id':       '#',
    'table.col.filename': 'Reporte',
    'table.col.size':     'Tamaño',

    // Request
    'title.requests':                'Peticiones',
    'btn.add_request':               'Nueva petición',
    'label.request.approval':        'Aprobación',
    'label.request.item':            'Elemento pedido',
    'label.request.urgency':         'Urgencia',
    'label.request.state.pending':   'Pendiente',
    'label.request.state.open':      'Abierto',
    'label.request.state.in-course': 'En curso',
    'label.request.state.delivered': 'Entregado',
    'label.request.state.closed':    'Cerrado',
    'request.button.cancel':         'Cancelar petición',
    'request.button.cancelDisable':  'Escribe un comentario para cancelar la petición',
    'request.button.comment':        'Comentar',
    'request.button.reactive':       'Reactivar petición',
    'request.button.reopen':         'Reabrir petición',
    'request.catalog.category':      'Categorías',
    'request.catalog.items':         'Elementos',
    'generic.error':                 'Lo sentimos, ha habido un error interno',

    'form.request.urgency.label':       'Urgencia',
    'form.request.urgency.placeholder': 'Seleccione la urgencia de la petición',

    'cookie.accept':       'Aceptar cookies',
    'cookie.moreInfo':     'Más información',
    'cookie.message':      'En las sesiones solo utilizamos cookies propias y de terceros, con finalidad técnica (aquellas que permiten al usuario la navegación a través del sitio web y la utilización de las diferentes opciones y servicios que en ella existen).', //Está bien así?
    'title.alert.request': 'Error en las peticiones',
    'title.catalog':       'Catálogos disponibles',

    // Alerts
    'title.alert.requests':        'Peticiones',
    'title.alert.reportsP200':     'Reporte mensual',
    'title.alert.internetClient':  'Acceso a internet',
    'title.alert.requestCatalog':  'Catálogo',
    'title.alert.requestsByState': 'Peticiones',
    'title.alert.requestItem':     'Peticiones',
    'title.alert.requestCategory': 'Peticiones',
    'error.undefined':             'Ha habido un error. Por favor pruebe más tarde',

    'requestCatalogError.title':  'Lo sentimos, ha habido un error en el servidor',
    'requestCatalogError.button': 'Pulsa aquí para probar de nuevo o espere unos segundos',

    // ERRORS
    DEFAULT_ERROR_MESSAGE: 'Por favor, revise los campos del formulario',
    BAD_REQUEST:           'La petición no es valida',
    DUPLICATE_ACCOUNT:     'La cuenta seleccionada ya existe',
    INVALID_PASSPHRASE:    'El passphrase introducido no es válido', //quedará passphase?
    INVALID_FORMAT:        'El formato del campo no es válido',
    INTERNAL_SERVER_ERROR: 'Lo sentimos, ha habido un error en el servidor',
    PERMISSION_DENIED:     'No tiene permisos para realizar está acción',
    VALIDATION_ERROR:      'Lo sentimos, ha habido un error de validación. Por favor, revise los campos del formulario',
    DUPLICATE_SERVICE:     'El servicio seleccionado ya dispone de un credencial asignado',
    PRIVATE_KEY_IS_EMPTY:  'Por favor, el campo clave privada no puede estar vacío',

    'form.credentials.help':                   '¿Necesita ayuda para conseguir las credenciales?',
    'button.copyToClipboard':                  'Copiar en el portapapeles',
    'help.credentials.awsServices.firstStep':  'Para obtener su clave de acceso y su clave secreta, por favor, visite este link',
    'help.credentials.awsServices.secondStep': 'Para agregar la política necesaria de IAM, por favor, cópiala o pulsa en "Copiar en el portapapeles" and,\n ' +
    'para configurarlo en AWS visite este ',

    'placeholder.requests.status': 'Estado',

    // ORACLE ACCOUNTS
    'title.alert.credential':                         'Credenciales',
    'title.alert.account':                            'Cuentas',
    'title.alert.oracleCredentials':                  'Credenciales de Oracle',
    'form.credentials.created.success':               'Se ha creado el credencial correctamente',
    'form.credentials.modified.success':              'Se ha editado el credencial correctamente',
    'form.credentials.deleted.success':               'Se ha eliminado el credencial correctamente',
    'form.credentials.created.error':                 'Error al crear el credencial',
    'form.credentials.modified.error':                'Error al editar el credencial',
    'form.credentials.deleted.error':                 'Error al eliminar el credencial',
    'form.account.edited.error':                      'Error al modificar la cuenta',
    'form.account.edited.success':                    'La cuenta se ha modificado correctamente',
    'form.credential.oracle.help.link':               'Si necesitas ayuda visite el siguiente enlace: ',
    'form.credential.oracle.help.doc':                'Documentación oficial de Oracle',
    'form.credential.oracle.userOcid.label':          'OCID del usuario',
    'form.credential.oracle.userOcid.placeholder':    'Identificador del usuario en Oracle',
    'form.credential.oracle.tenancyOcid.label':       'Tenancy OCID',
    'form.credential.oracle.tenancyOcid.placeholder': 'Identificador del tenancy en Oracle',
    'form.credential.oracle.privateKey.label':        'Clave privada del usuario',
    'form.credential.oracle.privateKey.change.label': 'Cambiar clave privada',
    'form.credential.oracle.passphrase.label':        'Passphrase (opcional)',
    'form.credential.oracle.fingerprint.label':       'Huella',
    'form.credential.oracle.uploadFile.label':        'Seleccionar archivo de clave privada',
    'form.credential.oracle.privatekey.placeholder':  'Cambiar la clave privada',
    'form.credential.oracle.passphrase.help':         'El passphrasse para el par de claves pública/privada, si ha especificado una al crear el par de claves.',

    BACKUP_CONSULT_SESSIONS:          'Copia de seguridad de consultas de sesiones',
    PROTECTED_BACKUP:                 'Copia de seguridad protegida',
    CMS_BACKUP_MONTHLY_CONSUMPTION:   'Copia de seguridad de consumo mensual',
    CMS_IAAS_MONTHLY_CONSUMPTION:     'Consumo mensual de CMS e IAAS',
    IAAS_MACHINE_ACTIVITY:            'Actividad de máquina IAAS',
    IAAS_CONSUMPTION_DETAIL:          'Detalle de consumo de IAAS',
    MONITORING_EVENTS:                'Eventos de monitorización',
    KECT_QUALITY_RESOLUTION:          'Calidad de resolución KECT',
    CKET_REOPENED:                    'CKET reabierto',
    CKET_RESOLUTION_TIME:             'Tiempo de resolución CKET',
    CKET_RESPONSE_TIME:               'Tiempo de respuesta CKET',
    KECT_VOLUMETRY_BY_CATEGORIZATION: 'Volumetria por categorización KECT',

    'title.link':                             'enlace',
    'cell.service.discovery':                 'descubrir recursos',
    'cell.service.start-stop':                'encender/detener recursos',
    'cell.service.support':                   'soporte',
    'cell.service.aws-support':               'soporte AWS',
    'cell.edit':                              'Editar credenciales para el servicio:',
    'cell.create':                            'Crear credenciales para el servicio: ',
    'cell.disable':                           'no está disponible para este proveedor',
    'title.alert.success.discovery.accounts': 'Iniciando proceso de descubrir',
    'title.alert.warning.discovery.accounts': 'Hay un problema para iniciar el proceso de descubrir recursos',
    discoverSuccess:                          'Descubriendo las siguientes cuentas: ',
    discoverWarning:                          'Las siguientes cuentas no disponen de credenciales para el servicio de descubrir',
    'discover.addCredential.title':           'Pulsa aquí para agregar credenciales de Servicio de Descobrir para esta cuenta',
    'support.button':                         'Soporte',

    'service-discovery':       'Descubrir recursos',
    'aws-support':             'Soporte AWS',
    'start-stop-vm':           'Encender/Detener VM',
    'title.service-discovery': 'Descubrir recursos',
    //'start-stop-vm':         'Start-Stop',
    support:                   'Soporte',

    // Credentials Cards
    'card.has.credential': 'Ya hay una credencial creada para esta cuenta',

    'title.billing_alerts':             'Alertas de Facturación',
    'title.billing_alert':              'Alerta de facturación',
    'title.alert.alert':                'Alertas de facturación',
    'title.billing_alerts.new':         'Nueva alerta de facturación',
    'label.billingAlerts.mode':         'Modo',
    'label.billingAlerts.name':         'Nombre de alerta',
    'label.billingAlerts.type':         'Tipo',
    'label.billingAlerts.entities':     'Elemento',
    'label.billingAlerts.amount':       'Cantidad en USD',
    'label.billingAlerts.state':        'Estado',
    'label.billingAlerts.active':       'Activa',
    'label.billingAlerts.active.form':  '¿Desea crear una alerta activa?',
    'label.billingAlerts.title':        'Alerta',
    'label.billingAlerts.emails':       'CC',
    'label.billingAlerts.lastRun':      'Última comprobación',
    'label.billingAlerts.modeHelpBulk': 'Elije el modo masivo si desea crear una alerta para cada elemento seleccionado', //Está bien así?
    'label.billingAlerts.modeHelpSum':  'Elije el modo de suma si desea crear una alerta para una suma de elementos', //Está bien así?

    'label.billingAlerts.name.placeholder':     'Nombre con el que quiere identificar la alerta',
    'label.billingAlerts.type.placeholder':     'Tipo de alerta',
    'label.billingAlerts.entities.placeholder': 'Elemento de la alerta',
    'label.billingAlerts.amount.placeholder':   'Cantidad máxima de la alerta',
    'label.billingAlerts.active.placeholder':   'Alarma activada',
    'label.billingAlerts.emails.placeholder':   'Direcciones de emails donde se notificará la alerta',
    'label.billingAlerts.remove.modal.title':   'Borrar alertas de facturación',
    'label.billingAlerts.remove.modal.message': '¿Está seguro de que desea borrar las siguientes alertas de facturación?',
    'label.billingAlerts.remove.modal.accept':  'Sí, borrar las alertas de facturación',
    'btn.add_billingAlert':                     'Añadir alerta de facturación',
    'btn.alerts.delete':                        'Borrar alertas de facturación',
    'placeholder.billingAlerts.search':         'Nombre de alerta, nombre del elemento...',
    'label.allStates':                          'Estado',
    'label.type':                               'Tipo',
    'form.alert.created.success':               'La alerta ha sido creada correctamente',
    'form.alert.updated.success':               'La alerta ha sido actualizada correctamente',
    'form.alert.delete.success':                'La alerta ha sido borrada correctamente',
    'form.alert.created.error':                 'Error al crear la alerta',
    'form.alert.updated.error':                 'Error al actualizar la alerta',
    'form.alert.deleted.error':                 'Error al borrar la alerta',
    'title.alert':                              'Alertas de facturación',

    'billingAlerts.entityType.accounts': 'Cuentas',
    'billingAlerts.entityType.projects': 'Proyectos',
    'billingAlerts.entityType.vendors':  'Proveedores',

    'billingAlerts.state.disabled': 'Deshabilitada',
    'billingAlerts.state.pending':  'Pendiente',
    'billingAlerts.state.ok':       'OK',
    'billingAlerts.state.warning':  'Advertencia',
    'billingAlerts.state.reached':  'Alcanzada',
    cannontBeEmpty:                 'Por favor, elija al menos un elemento',

    'form.billingAlerts.entities.modal.accounts': 'Cuentas',
    'form.billingAlerts.entities.modal.projects': 'Proyectos',
    'form.billingAlerts.entities.modal.vendors':  'Proveedores',

    'form.modal.billingAlerts.close':   'No, no quiero',
    'form.modal.billingAlerts.remove':  'Sí, borrar esta alerta de facturación',
    'form.modal.billingAlerts.message': '¿Está seguro de que quiere borrar la alerta de facturación?',

    'title.alert.billingAlertsTypes':  'Tipos de alertas de facturación',
    'title.alert.billingAlertsStates': 'Estados de alertas de facturación',
    'title.alert.billingAlerts':       'Alertas de facturación',

    IS_EMPTY:                   'Este campo no puede estar vacio',
    'title.billingAlertsTypes': 'Alertas de facturación',

    NOT_ALLOWED_ACCOUNT: 'Lo sentimos, esta cuenta no tiene permisos para realizar esta acción',
    INVALID_PAYLOAD:     'Lo sentimos, ha habido un error de validación. Revise los campos del formulario',

    description:   'Descripción',
    attachments:   'Adjuntos',
    category_code: 'Categoria',
    cc:            'Emails',
    severity_code: 'Severidad',
    subject:       'Título',
    service:       'Servicio',
    category:      'Categoria',
    account_id:    'Cuenta',

    'url.cookieConsent': 'https://www.equinix.es/company/legal/privacy/',

    'btn.stopResource':               'Detener recurso',
    'form.modal.resource.stop':       'Si, quiero detener este recurso',
    'btn.startResource':              'Iniciar recurso',
    'form.modal.resource.start':      'Si, quiero iniciar este recurso',
    'btn.stopResource.list':          'Detener los siguientes recursos:',
    'form.modal.resource.stop.list':  'Si, quiero detener los siguientes recursos',
    'btn.startResource.list':         'Iniciar los siguientes recursos',
    'form.modal.resource.start.list': 'Si, quiero iniciar los siguientes recursos',

    'title.alert.oracleAccounts':     'Cuentas de Oracle',
    'title.alert.awsSupportComments': 'Soporte Amazon Web Services',

    'label.amount':              'Cantidad:',
    'form.alerts.label.help':    'Puedes agregar más de un email separándolos con las teclas Intro, espacio, tabulador o coma',
    mandatoryCookiesLabel:       'Cookies obligatorias',
    googleAnalyticsLabel:        'Google Analytics',
    googleAnalyticsDescription:  'Recopilación de los datos necesarios del usuario para mejorar su experiencia',
    mandatoryCookiesDescription: 'Cookies necesarias para el buen funcionamiento de la aplicación',

    'form.credential.google.credentialsFile.placeholder':      'Fichero de credenciales',
    'form.credential.google.credentialsFile.placeholder.new':  'Adjuntar el archivo con las claves de la cuenta del servicio',
    'form.credential.google.credentialsFile.placeholder.edit': 'Cambiar archivo de las claves de la cuenta del servicio',
    'form.credential.google.credentialsFile.label':            'Claves de la cuenta del servicio',
    'form.credential.google.credentialsFile.change.label':     'Cambiar archivo de las claves de la cuenta del servicio',
    'form.credential.help.link':                               'Si necesita ayuda para crear sus credenciales, visite el siguiente enlace: ',
    'form.credential.help.website':                            'Cloudglass blog',
    'form.credential.google.currentCredentials':               'Claves actuales de la cuenta de servicio: ',
    'title.alert.googleCredentials':                           'Credenciales de Google',
    'title.google.handlePermissions':                          'Comprobar permisos',
    'label.accept':                                            'Aceptar',
    'label.checkbox.notShowAgain':                             'No volver a mostrar este mensaje',
    'label.newFeatures.message':                               'Hemos actualizado Cloudglass con las siguientes funciones:',
    'title.managePermissions':                                 'Manejar permisos de cookies',
    'title.modifyCredentials':                                 'Modificar credenciales de la cuenta',
    'title.editCredentials':                                   'Editar credenciales',
    'form.billingAlerts.cc.label':                             'Direcciones de emails donde se notificará la alerta',

    'alert.updateData':                         'Los datos se actualizaron', //podria ser "Ultima actualización"?
    'title.ActiveEvents':                       'Eventos activos',
    'title.AllEvents':                          'Todos los eventos',
    'title.active.closed.events':               'Total de eventos activos y cerrados',
    'title.monitoring':                         'IT monitoring',
    'title.events':                             'Eventos',
    'title.DetailEvents':                       'Detalles',
    'label.openEventsBySeverity':               'Eventos abiertos por severidad',
    'label.totalEventsBySeverity':              'Todos los eventos por severidad',
    'label.top10CIWithActiveEvents':            'Top 10 CI con eventos activos',
    'label.top10CIWithInactiveEvents':          'Top 10 CI con eventos cerrados',
    'label.CIByCIClass':                        'Eventos por clase de CI',
    'label.CiClass':                            'Clase CI',
    'label.allCiClass':                         'Todas las clases CI disponibles',
    'label.OpenEventsByclass':                  'Eventos abiertos por clase',
    'label.eventsByclass':                      'Eventos por clase',
    'label.top10MonitorClassWithActiveEvents':  'Top 10 Object class con eventos activos', //no hay traduccion para object class
    'label.top10MonitorClassTotalEvents':       'Top 10 Object class', //no hay traduccion para object class
    'label.top10MonitorCITotalEvents':          'Top 10 CI',
    'label.top10ObjectClassWithInactiveEvents': 'Top 10 Object class con eventos cerrados', //no hay traduccion para object class
    'label.hourlyPerDaySeverity':               'Eventos diarios agrupados por severidad',
    'label.numberActiveEvents':                 'Eventos activos',
    'label.numberInactiveEvents':               'Eventos cerrados',
    'label.numberEvents':                       'Eventos',
    hour:                                       'Fecha de creación',
    closedDate:                                 'Fecha de cierre',
    severity:                                   'Severidad',
    node:                                       'CI',
    object:                                     'Objecto',
    objectClass:                                'Object Class', //no hay traduccion para object class
    operable:                                   'Operable por Equinix',
    'monitoring.allEvents':                     'Todos los eventos',
    'monitoring.OperatedByEquinixSupport':      'Eventos operados por Equinix',
    'monitoring.NoOperatedByEquinix':           'Eventos no operados por Equinix',
    'label.monitoring.operable.false':          'No',
    'label.monitoring.operable.true':           'Si',
    'field.closedDate':                         'Ticket abierto',

    'label.bulkMode':          'Se crearán {totalAlerts} alertas independientes. Una por cada uno de los elementos seleccionados, por una cantidad total de {amount} cada una.',
    'label.bulkMode.vendor':   'Se crearán {totalAlerts} alertas independientes. Una por cada uno de los proveedores cloud seleccionados, por una cantidad total de {amount} cada una.',
    'label.bulkMode.accounts': 'Se crearán {totalAlerts} alertas independientes. Una por cada una de las cuentas seleccionadas, por una cantidad total de {amount} cada una.',
    'label.bulkMode.projects': 'Se crearán {totalAlerts} alertas independientes. Una por cada uno de los proyectos seleccionados, por una cantidad total de {amount} cada una.',
    'label.sumMode':           'Se creará una alerta que se activará cuando todos los elementos seleccionados sumen un total de {amount}.',
    'label.editSumMode':       'La alerta se activará cuando todos los elementos seleccionados sumen un total de {amount}.',

    'label.sumMode.accounts': 'Se creará una alerta que se activará cuando todas los proyectos seleccionados sumen un total de {amount}.',
    'label.sumMode.projects': 'Se creará una alerta que se activará cuando todas las cuentas seleccionadas sumen un total de {amount}.',
    'label.sumMode.vendor':   'Se creará una alerta que se activará cuando todos los proveedores de servicios en la nube seleccionados sumen un total de {amount}.',

    'label.bulkModeModal':        'Se crearán {totalAlerts} alertas independientes para cada uno de los elementos seleccionados.',
    'label.sumModeModal':         'Se creará una alerta que se activará cuando todos los elementos seleccionados sumen el total que se especifique.',
    'label.modal.selectVendor':   'Seleccione uno o más proveedores',
    'label.modal.selectAccounts': 'Seleccione una o más cuentas',
    'label.modal.selectProjects': 'Seleccione uno o más proyectos',
    'label.modal.select':         'Seleccione uno o más elementos',

    'form.saveAndBack': 'Guardar',

    'label.selectAlerts': 'Seleccionar alertas',

    'table.consolidateLastRun.name':    'Nombre',
    'table.consolidateLastRun.lastRun': 'Actualizado',
    'title.alert.consolidateLastRun':   'Última actualización',
    'btn.showDetails':                  'Mostrar detalles',
    'btn.backToTotals':                 'Volver a los totales',

    // CLOUD BILLING
    'label.difference':    '{selected} por {prev}', // así está bien?
    'label.previousMonth': 'Mes anterior',

    'title.alert.cloudBillingProjects': 'Proyectos',
    'title.alert.cloudBillingServices': 'Servicios',
    'title.alert.cloudBillingAccounts': 'Cuentas',
    'title.alert.cloudBillingVendors':  'Proveedores',
    'title.alert.cloudBillingRegions':  'Regiones',

    'title.alert.costCenters': 'Projects',
    'title.alert.tenant':      'Tenant', //no hay traduccion. Hay alguna opción mejor?

    'title.accountsToDiscover': 'Seleccione las cuentas que desee descubrir',

    'title.portals':       'Servicios Gestionados',
    'title.tenant.alert':  'Tenant', //no hay traduccion. Hay alguna opción mejor?
    'label.otherPortals':  'Otros portales',
    'label.quickLinks':    'Enlaces Útiles',
    'label.customerVoice': 'Customer Voice',
    'label.logginTenant':  'Iniciar sesión',

    accounts: 'Cuentas',
    projects: 'Proyectos',
    services: 'Servicios',
    regions:  'Regiones',
    vendors:  'Proveedores',

    entityDetail: 'Detalle',

    account:           'Cuenta',
    vendor:            'Proveedor',
    region:            'Región',
    project:           'Proyecto',
    product:           'Servicio',
    cost_center:       'Proyecto',
    monthlySpending:   'Gasto mes actual',
    previousSpending:  'Gasto mes anterior',
    percent:           'Porcentaje de gasto',
    selectionSpending: 'Gasto de la selección: ',
    selectionResume:   'Selección',

    accountSingular: 'cuenta',
    accountPlural:   'cuentas',
    vendorSingular:  'proveedor',
    vendorPlural:    'proveedores',
    regionSingular:  'región',
    regionPlural:    'regiones',
    projectSingular: 'proyecto',
    projectPlural:   'proyectos',
    serviceSingular: 'servicio',
    servicePlural:   'servicios',
    entity:          'Item',

    labelSelectedEntities:   'Hay {selected} elementos seleccionados ({total} en total)',
    labelSelectedEntities2:  'Hay {selected} elementos seleccionados. {total} en total.',
    labelSelectAllEntities:  'Seleccionar {select} elementos',
    entityTableTitle:        '¿Cuánto es el coste de mis {selected}?',
    subEntityTableTitle:     '¿Qué {subEntitySelected} pertenece a mis {selected}?',
    selectedTableMessage:    'Los elementos seleccionados han consumido {amount} durante {selectedMonth}',
    allPageEntitiesSelected: 'Todos los elementos de la página están seleccionados',
    noEntitiesSelected:      'No hay elementos seleccionados',
    createAlertFor:          'Crear alerta para el elemento: ',

    thereAre:            'Hay ',
    selectedEntities:    ' elementos seleccionados',
    select2:             'Seleccionar',
    entities:            'elementos',
    allEntitiesSelected: 'Todos los elementos están seleccionados',
    inTotal:             'en total',

    cloudBillingBreakdownButton: 'Desglose',
    cloudBillingExportButton:    'Descargar',
    cloudBillingCreateAlert:     'Crear alerta',

    placeholderEntitySearch: 'Buscar...',
    showSelected:            'Mostrar selección',
    showSelectedTooltip:     'Pulse para mostrar solo los elementos seleccionados',
    showBreakdown:           'Ver desglose de la selección',
    showAllEntities:         'Mostrar todos los elementos',

    select:               'Seleccionar elementos',
    selectAllEntities:    'Seleccionar todos los items',
    selectPageEntities:   'Seleccionar los elementos de la página',
    unselectPageEntities: 'Desmarcar todos los elementos de la página',
    unselectAllEntities:  'Desmarcar todos los elementos',
    leaveSelected:        'Mostrar todo',

    chartWidgetTitle:  'Gasto total',
    dailyChartTitle:   'Diario',
    monthlyChartTitle: 'Anual',
    last12MonthsTitle: 'Últimos 12 meses',
    yearToDateTitle:   'YTD',
    yearToDateTooltip: 'Año en curso',

    chartMainTitleDaily:        'Consumo diario de la selección',
    chartMainTitleYTD:          'Consumo del año en curso de la selección',
    chartMainTitleLast12Months: 'Consumo de los últimos 12 meses de la selección',
    chartMainTitleAnnual:       'Historial de consumo de la selección',

    labelSelectedAccounts: 'Hay {selected} cuentas seleccionadas ({total} en total)',
    labelSelectedVendors:  'Hay {selected} proveedores seleccionados ({total} en total)',
    labelSelectedRegions:  'Hay {selected} regiones seleccionadas ({total} en total)',
    labelSelectedProjects: 'Hay {selected} proyectos seleccionados ({total} en total)',

    labelUnlock:            'El marcador está guardado. Pulse para eliminarlo.',
    labelLock:              'Guardar marcador',
    'label.bookmark':       'marcador',
    editBookmarkName:       'Cambiar nombre',
    'label.bookmark.empty': 'No hay ningún marcador creado. Para añadir uno, seleccione los elementos que quieres que contenga y pulse el botón con el icono "',

    percentDifference:       'respecto al mes anterior',
    createAlert:             'Crear alerta',
    cloudBillingTitleResume: 'Explorer',
    spendingBreakdown:       'Desglose',
    totalSpending:           'Gasto de la selección',

    projectsSelectedSpending: 'Los proyectos seleccionados han consumido {amount} durante el mes de {selectedMonth}',
    accountsSelectedSpending: 'Las cuentas seleccionadas han consumido {amount} durante el mes de {selectedMonth}',
    vendorsSelectedSpending:  'Los proveedores seleccionados han consumido {amount} durante el mes de {selectedMonth}',
    servicesSelectedSpending: 'Los servicios seleccionados han consumido {amount} durante el mes de {selectedMonth}',
    regionsSelectedSpending:  'Las regiones seleccionadas han consumido {amount} durante el mes de {selectedMonth}',
    defaulTitleSpendingError: 'Lo sentimos, ha habido un error',

    projectsSelectedTableTitle: 'Consumo de mis proyectos',
    accountsSelectedTableTitle: 'Consumo de mis cuentas',
    servicesSelectedTableTitle: 'Consumo de mis servicios',
    vendorsSelectedTableTitle:  'Consumo de mis proveedores',
    regionsSelectedTableTitle:  'Consumo de mis regiones',

    subEntityTitle: '¿Qué {subEntity} pertenecen a mis {entity}?',

    projectTitle: 'proyectos',
    regionTitle:  'regiones',
    serviceTitle: 'servicios',
    vendorTitle:  'proveedores',
    accountTitle: 'cuentas',

    labelResumeSelectedAccounts:           'Hay {selected} cuentas seleccionadas ({total} en total)',
    labelResumeSelectedProjects:           'Hay {selected} proyectos seleccionados ({total} en total)',
    labelResumeSelectedRegions:            'Hay {selected} regiones seleccionadas ({total} en total)',
    labelResumeSelectedVendors:            'Hay {selected} proveedores seleccionados ({total} en total)',
    labelResumeSelectedServices:           'Hay {selected} servicios seleccionados ({total} en total)',
    'label.cloudBilling.selectedItem':     'Hay {selectedItems} {entityType} seleccionados ({totalItems} en total)',
    'label.cloudBilling.selectedBookmark': 'Hay {selectedItems} {entityType} este mes ({totalItems} guardados en el marcador)',
    'label.breakdown.entityTab':           'Hay {totalItems} {entityType} en total',


    RESOURCES:               'Recursos',
    MONITORING:              'Monitorización',
    STORAGE:                 'Almacenamiento',
    BACKUP:                  'Backup',
    CLOUD_BILLING:           'Facturación de la Nube',
    EXPORT_ACTION:           'descargar',
    EXPORT_SUCCESS:          'Se ha descargado el reporte correctamente',
    EXPORT_ERROR:            'Ha habido un error al descargar el reporte',
    ERROR_WEBSOCKET:         'Ha habido un error durante la conexión',
    'download.notification': 'Puedes descargar tu archivo aquí: ',
    nextFeaturesMessage:     'Esta opción estará disponible pronto. Gracias.',
    customSelection:         'Selección propia',

    websocketsDownloadMessage:            'Recibirás una notificación cuando el reporte este disponible',
    'title.alert.cloudBillingWebSockets': 'Descargar reporte',
    webSocketsDownloadError:              'Ha habido un problema al crear el reporte',

    'title.alert.monitoringHost':             'Hosts',
    'title.alert.monitoringAlarms':           'Eventos',
    'title.alert.monitoringClientsId':        'CI por serveridad',
    'title.alert.monitoringClientsIdClasses': 'CI por clase',
    'title.alert.monitoringDaysBySeverity':   'Eventos severidad diarios',
    'title.alert.monitoringEvents':           'Events por severidad',
    'title.alert.monitoringObjectsId':        'Object class por severidad',
    'Cloud Billing':                          'Facturación de la Nube',

    'title.impersonate':        'Impersonalizar',
    'btn.returnImpersonate':    'Volver a tu usuario',
    'label.impersonate.search': 'Nombre, email, cliente, cuenta...',

    'label.azureToken.error':   'No se ha podido actualizar el token de Azure CSP',
    'label.azureToken.success': 'Se ha actualizado el token de Azure CSP',

    'title.modal.deleteBookmark':       'Borrar marcador',
    'text.modal.deleteBookmark':        '¿Está seguro de que desea eliminar el siguiente marcador?',
    'text.modal.deleteBookmark.accept': 'Sí, borrar marcador',

    'title.serviceNotFound':         '¿Está interesado en este servicio?',
    'title.serviceNotFound.service': '{service}',

    // CLOUD BILLING TOGGLE BUTTON
    'btn.aggregate': 'Acumulado',

    // CUSTOMER VOICE
    'customer-voice-title':        'Customer Voice',
    'customer-voice-description1': 'Queremos saber tu opinión. La experiencia de nuestros clientes nos importa y queremos saber como podemos mejorar o si lo estamos haciendo bien.',
    'customer-voice-description2': 'Te puedes poner en contacto con nostros a través de:',
    'customer-voice-option1':      'Poniéndote en contacto con tú Service Manager',
    'customer-voice-option2':      'Completando tickets de encuestas',
    'customer-voice-option3':      'Haciendo click',
    'customer-voice-option4':      'Aquí',
    'customer-voice-thanks':       'Muchas gracias!',

    // NOT AUTHORIZED
    publicCloud: 'Nube Pública',
    hybridCloud: 'Cloud Híbrida',

    'notAuthorized.accessDenied': 'Acceso denegado',

    'notAuthorized.contact': 'Para solicitar información sobre este servicio, por favor comuníquese con el Account Executive que tiene asignado o escribe un correo a la siguiente dirección:',

    'notAuthorized.backups.description':                 'Mantenga su información crítica segura y replicada con el servicio Equinix Backup. Ofrecemos tres tipos de cópia de seguridad:',// he mantenido la version en ingles del codigo y no la que está en el archivo de traducciones
    'notAuthorized.backups.option1.name':                'Copia de seguridad inteligente:', //no hay traduccion. está bien así?
    'notAuthorized.backups.option2.name':                'Copia de seguridad remota:',
    'notAuthorized.backups.option3.name':                'Protección en la nube:', //no hay traduccion. está bien así?
    'notAuthorized.backups.option1.description':         'Infraestructura dentro de nuestros IBX.',
    'notAuthorized.backups.option2.description':         'Infraestructura en el cliente.',
    'notAuthorized.backups.option3.description':         'Infraestructura en la nube pública.',
    'notAuthorized.backups.feature.title':               'Principales características:',
    'notAuthorized.backups.feature.option1':             'Servicio operado, monitorizado y con soporte en 24x7.',
    'notAuthorized.backups.feature.option2':             'Reduplicación y cifrado de datos en origen y destino.',
    'notAuthorized.backups.feature.option3':             'Copias de seguridad incrementales, sin límite y sintética completa.',
    'notAuthorized.backups.feature.option4.name':        'Opcional:',
    'notAuthorized.backups.feature.option5.name':        'Política de retenciones:',
    'notAuthorized.backups.feature.option4.description': 'Doble copia, integración de aplicaciones, copia cruzada, etc.',
    'notAuthorized.backups.feature.option5.description': 'Básica, estándar y extendida.',

    'notAuthorized.eqxIaas.description':     'Equinix propone su servicio IaaS permitiendo a nuestros clientes auto-desplegarse una infraestructura cloud, potente, flexible y basada en los estándares y tecnologías líderes en el mercado. Principales características:',
    'notAuthorized.eqxIaas.option1':         'Portal de Auto-provisión del Centro de Datos Virtual',
    'notAuthorized.eqxIaas.option2':         'Servicios de red definidos por software (SDN) y Gateway (Rounting, Balancing, NAT, VPN, etc).',
    'notAuthorized.eqxIaas.option3':         'Cuatro ubicaciones: MD1, MD2, BA1 y SA1.',
    'notAuthorized.eqxIaas.option4':         'Dos modalidades: Estándar vDC o vDC Geo-extendido (RPO=0).',
    'notAuthorized.eqxIaas.option5':         'Despliegue en entorno compartido o dedicado.',
    'notAuthorized.eqxIaas.option6':         'Dos niveles de disco: capacidad y rendimiento extremo.',
    'notAuthorized.eqxIaas.option7':         'Catálogo estándar y personalizado de sistemas operativos y plantillas.',
    'notAuthorized.eqxIaas.option8':         'Servicios adicionales:',
    'notAuthorized.eqxIaas.option8.option1': 'Acceso a internet.',
    'notAuthorized.eqxIaas.option8.option2': 'Posibilidad de conexión directa P2P o MPLS (puertos de 1 Gbit o 10 Gbit).',
    'notAuthorized.eqxIaas.option8.option3': 'Antivirus como servicio.',
    'notAuthorized.eqxIaas.option8.option4': 'Provisión de licencias y BYOL.',
    'notAuthorized.eqxIaas.option8.option5': 'Almacenamiento NAS',

    'notAuthorized.monitoring.description': 'Equinix propone su servicio de Monitorización permitiendo detectar, registrar y notificar eventos para prevenir incidencias en el entorno IT. El servicio lo compone una suite de herramientas especializadas para cada entorno, ofreciendo múltiples beneficios:',
    'notAuthorized.monitoring.option1':     'Interfaz gráfica unificada.',
    'notAuthorized.monitoring.option2':     'Generación automática de notificaciones y escalados (MANS).',
    'notAuthorized.monitoring.option3':     'Correlación de eventos.',
    'notAuthorized.monitoring.option4':     'Recopilación flexible de métricas de sistemas y servicios.',
    'notAuthorized.monitoring.option5':     'Generación de eventos según la disponibilidad o el rendimiento.',
    'notAuthorized.monitoring.option6':     'Informes diarios de eventos y alarmas.',
    'notAuthorized.monitoring.option7':     'Servicio integrado con nuestra herramienta ITSM para el seguimiento de alertas.',

    'notAuthorized.smartmonitoring.description': 'Equinix propone su servicio de Monitoring permitiendo detectar, registrar y notificar eventos para prevenir incidencias en el entorno IT. El servicio lo compone una suite de herramientas especializadas para cada entorno, ofreciendo múltiples beneficios:',
    'notAuthorized.smartmonitoring.option1':     'Posibilidad de acceso mediante multi-dispositivo.',
    'notAuthorized.smartmonitoring.option2':     'Personalice su panel por el tipo de servicio.',
    'notAuthorized.smartmonitoring.option3':     'Interfaz gráfica amigable y unificada.',
    'notAuthorized.smartmonitoring.option4':     'Configuración de métricas en entornos híbridos: On-prem, Equinix IaaS, AWS, GCP, Azure, OCI, Alicloud.',

    'notAuthorized.publiccloud.description1': 'Equinix ofrece el servicio de Reventa de las Nubes Publicas más reconocidas del mercado, con los cuales mantiene los más altos niveles de colaboración desde su establecimiento en Europa, siendo Premier de Amazon Web Services, Google Cloud,  Microsoft Azure Gold Partner, Oracle Cloud y Alibaba Cloud.',
    'notAuthorized.publiccloud.description2': 'Nuestros ingenieros aportan los conocimientos específicos en consultoría, arquitectura, despliegue y migraciones a las nubes públicas hiper escala principales con más de 150 certificaciones en los principales servicios.',

    'notAuthorized.hybridcloud.description1':   'El objetivo de Equinix es acompañar a nuestros clientes en su camino hacia la transformación digital. Para ello, se presenta como imprescindible el uso de soluciones de cloud híbridas que permiten a nuestros clientes disfrutar tanto de los beneficios del cloud privado como público.',
    'notAuthorized.hybridcloud.description2':   'Equinix, a través de su servicio ',
    'notAuthorized.hybridcloud.description2.2': ', permite el establecimiento de conexión privadas y seguras en minutos a través del portal del servicio, con multitud de proveedores de servicios.',

    'notAuthorized.iaas.description1': 'Infrastructure Platform Service (IPS) provee de un servicio de datacenter virtual, totalmente definido por software, cubriendo las capas de cómputo, red y almacenamiento, a través de una herramienta de auto-provisión.',
    'notAuthorized.iaas.description2': 'El servicio cuenta con diferentes zonas de disponibilidad que permiten desplegar Virtual Datacenters en nuestros IBXs (MD1, MD2, BA1 y SA1), ya sea, trabajando de manera independiente o combinándolos entre sí desplegando un Virtual Datacenter Geoextendido (MD1-MD2).',
    'notAuthorized.iaas.description3': 'Se ofrecen dos modalidades de cómputo:',
    'notAuthorized.iaas.option1':      'Flexible Compute: Esta modalidad proporciona a sus clientes, recursos informáticos (vCPU y vRAM), almacenamiento y elementos de red en una plataforma compartida para el alojamiento virtual del total sus recursos para ofrecer la máxima flexibilidad en cuanto a dimensionamiento de las máquinas.',
    'notAuthorized.iaas.option2':      'Dedicated Host: Esta modalidad proporciona recursos de cómputo (vCPU y vRAM) de uso exclusivo y dedicado para nuestros clientes. Estos recursos se proveen con servidores físicos de virtualización dedicados para el cliente, pero conservando las mismas herramientas y funcionalidades.',

    'notAuthorized.storage.description':                 'Equinix propone su servicio de Almacenamiento para almacenar el dato del cliente de forma privada, segura, tolerante a fallos y en consumo de pago por uso. Se ofrecen dos modalidades:',
    'notAuthorized.storage.option1':                     'Almacenamiento SAN: Almacenamiento modo bloque accesible mediante protocolo FC a través de redes SAN redundantes de baja latencia.',
    'notAuthorized.storage.option2':                     'Almacenamiento NAS: Almacenamiento modo archivo accesible mediante protocolo CIFS o NFS a través de redes Ethernet redundantes.',
    'notAuthorized.storage.feature.title':               'Principales características:',
    'notAuthorized.storage.feature.option1':             'Servicio operado, monitorizado y con soporte en 24x7.',
    'notAuthorized.storage.feature.option2':             'Disponible en diferentes tipos de disco: Rendimiento Extremo (SSD) y Capacidad (NL-SAS).',
    'notAuthorized.storage.feature.option3':             'Sistemas redundantes en todos los componentes y con módulos caché para acelerar las operaciones de IO.',
    'notAuthorized.storage.feature.option4':             'Integración con VMWare VAAI',
    'notAuthorized.storage.feature.option5.name':        'Servicios opcionales:',
    'notAuthorized.storage.feature.option5.description': 'Almacenamiento geoextendido activo con acceso activo, replicación Asíncrona con RPO mínimo y snapshots/clones.',

    // WIZARD
    'label.credentials.initial.state': 'Seleccione una cuenta',
    'label.credentials.second.state':  'Elija un servicio',
    'label.credentials.third.state':   'Añade y guarde sus credenciales',

    //Check Version
    'title.modal.checkVersion':       'Nueva versión',
    'text.modal.checkVersion.accept': 'Recargar',
    'description.modal.checkVersion': 'Se ha detectado una nueva versión de Cloudglass. Por favor, vuelve a cargar la aplicación.',

    // Not available
    'text.not.available': 'El acceso a los servicios gestionados está fuera de servicio temporalmente por tareas de mantenimiento.',

    // Storage reports
    'title.storage.NAS':                      'NAS',
    'title.storage.SAN':                      'SAN',
    'title.storage.objects':                  'Objetos',
    'title.storage.detail':                   'Detalles',
    'title.storage-reports':                  'Informes de almacenamiento',
    'title.storagePlatform':                  'Almacenamiento',
    'chart.storage.occupancy':                'Ocupación de almacenamiento',
    'chart.storage.assigned':                 'Almacenamiento asignado (TB)',
    'chart.label.assigned':                   'Asignado',
    'chart.label.free':                       'Libre',
    'chart.label.used':                       'Utilizado',
    'storage.select.volume.placeholder':      'Seleccione un volumen',
    'storage.select.bucket.placeholder':      'Seleccione un bucket',
    'storage.select.volume.title':            'Volúmenes',
    'storage.select.volume.loading':          'Cargando volúmenes...',
    'storage.select.bucket.loading':          'Cargando buckets...',
    'storage.table.column.ibx':               'IBX',
    'storage.table.column.replicaType':       'Tipo de réplica',
    'storage.table.column.volumeName':        'Nombre del volumen',
    'storage.table.column.assignedSpace':     'Espacio asignado',
    'storage.table.column.usedSpace':         'Espacio usado',
    'storage.table.column.descPoe':           'Desc. Poe',
    'storage.table.column.serviceName':       'Nombre del servicio',
    'storage.table.entity.singular':          'almacenamiento',
    'storage.table.entity.plural':            'almacenamientos',
    'storage.table.filter.columnFilter':      'Columna para buscar',
    'storage.table.filter.storageTechnology': 'Tecnología de almacenamiento',
    'storage.table.filter.search':            'Valor a buscar en la columna...',
    'title.alert.storageAssigned':            'Almacenamiento asignado',
    'title.alert.storageOccupancy':           'Almacenamiento ocupado',
    'title.alert.storageVolume':              'Volumen del almacenamiento',
    'title.alert.storageDetail':              'Detalle del almacenamiento',

    // CMDB
    'title.cmdbReports':                                       'CMDB e Informes',
    'title.cmdb-dashboard':                                    'CMDB dashboard',
    'title.cmdb-reports':                                      'Informes',
    'cmdb.allDevices':                                         'Todos los dispositivos',
    'cmdb.OperatedByEquinixSupport':                           'Dispositivos operados por Equinix',
    'cmdb.NoOperatedByEquinix':                                'Dispositivos no operados por Equinix',
    'title.cmdb.globalCMDBInformation':                        'Información general de CMDB',
    'title.cmdb.tab.globalCMDBInformation':                    'Información general de CMDB',
    'chart.cmdb.globalCMDBCake':                               'CIs activos en CMDB',
    'chart.cmdb.globalCMDBLast13Months':                       'CIs activos en CMDB (Últimos 13 meses)',
    'chart.cmdb.globalCMDBLast13Months.label':                 'CIs activos en CMDB',
    'chart.cmdb.CMDBBackupCake':                               'Copia de seguridad',
    'chart.cmdb.CMDBBackupLast13m':                            'Copia de seguridad (Últimos 13 meses)',
    'chart.cmdb.CMDBBackupCake.withBackup.label':              'CIs con copia de seguridad',
    'chart.cmdb.CMDBBackupCake.withoutBackup.label':           'CIs sin copia de seguridad',
    'chart.cmdb.CMDBMonitoringCake':                           'Plataforma de monitorización',
    'chart.cmdb.CMDBMonitoringCake.withMonitoring.label':      'CIs con monitorización',
    'chart.cmdb.CMDBMonitoringCake.withoutMonitoring.label':   'CIs sin monitorización',
    'chart.cmdb.CMDBMonitoringLast13m':                        'Plataforma de monitorización (Últimos 13 meses)',
    'chart.cmdb.CMDBPatchCake':                                'Proceso de parcheo',
    'chart.cmdb.CMDBPatchCake.withoutPatch.label':             'CIs sin parcheos',
    'chart.cmdb.CMDBPatchCake.withPatch.label':                'CIs con parcheos',
    'chart.cmdb.CMDBPatchLast13m':                             'Proceso de parcheo (Últimos 13 meses)',
    'title.cmdb.CMDBDetails':                                  'Detalles CMDB',
    'title.cmdb.tab.CMDBDetails':                              'Detalles CMDB',
    'cmdb.table.service.column.ci_name':                       'Nombre de CI',
    'cmdb.table.service.column.class_name':                    'Nombre de clase',
    'cmdb.table.service.column.with_backup':                   'Copia de seguridad',
    'cmdb.table.service.column.last_backup':                   'Fecha de la última copia de seguridad',
    'cmdb.table.service.column.with_monitoring':               'Monitorización',
    'cmdb.table.service.column.windows_patch':                 'Ventana de parcheo',
    'cmdb.table.service.column.last_patch_date':               'Fecha del último parcheo',
    'cmdb.table.service.column.patch_status':                  'Estado de parcheo',
    'cmdb.table.service.column.managed':                       'Gestionado',
    'cmdb.table.service.column.patch_status.patched':          'OK',
    'cmdb.table.service.column.patch_status.reached_eol':      'EOL',
    'cmdb.table.service.column.patch_status.no_patch_windows': 'Sin ventana de parcheo',
    'cmdb.table.service.column.patch_status.warning':          'Advertencia',
    'cmdb.table.service.column.patch_status.not_patched':      'No parcheado',
    'cmdb.table.service.column.patch_status.not_upgradable':   'No parcheado',
    'cmdb.services.table.entity.singular':                     'servicio',
    'cmdb.services.table.entity.plural':                       'servicios',
    'cmdb.devices.table.entity.singular':                      'dispositivo',
    'cmdb.devices.table.entity.plural':                        'dispositivos',
    'cmdb.title.widget.services_details':                      'Detalles del servicio',
    'cmdb.title.widget.devices_details':                       'Detalles del dispositivo',
    'cmdb.table.device.column.ci_name':                        'Nombre de CI',
    'cmdb.table.device.column.class_name':                     'Nombre de la clase',
    'cmdb.table.device.column.operating_system':               'Sistema operativo',
    'cmdb.table.device.column.manufacturer':                   'Fabricante',
    'cmdb.table.device.column.memory_gb':                      'Memoria',
    'cmdb.table.device.column.cpu':                            'CPU',
    'cmdb.table.device.column.cpu_core':                       'Núcleos de la CPU',
    'cmdb.table.device.column.model':                          'Modelo',
    'cmdb.table.device.column.eol':                            'EoL Sistema Operativo',
    'cmdb.table.service.label.yes':                            'Si',
    'cmdb.table.service.label.no':                             'No'
};



// WEBPACK FOOTER //
// ./src/locales/es.js